import { Texture, DisplayObject, Application, Container, Point, ObservablePoint, extras, Graphics, mesh, particles, Sprite, Text } from "pixi.js";
import React, { useEffect, useContext } from "react";

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}

function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {},
        r = Object.keys(n);
    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
      return Object.getOwnPropertyDescriptor(n, e).enumerable;
    }))), r.forEach(function (t) {
      _defineProperty(e, t, n[t]);
    });
  }

  return e;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _objectWithoutPropertiesLoose(e, t) {
  if (null == e) return {};
  var n,
      r,
      i = {},
      o = Object.keys(e);

  for (r = 0; r < o.length; r++) {
    n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
  }

  return i;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};

  var n,
      r,
      i = _objectWithoutPropertiesLoose(e, t);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);

    for (r = 0; r < o.length; r++) {
      n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
    }
  }

  return i;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _nonIterableSpread();
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) {
    for (var t = 0, n = new Array(e.length); t < e.length; t++) {
      n[t] = e[t];
    }

    return n;
  }
}

function _iterableToArray(e) {
  if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var validateFormat = function validateFormat(e) {
  if (void 0 === e) throw new Error("invariant(...): Second argument must be a string.");
};

function invariant(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++) {
    r[i - 2] = arguments[i];
  }

  if (validateFormat(t), !e) {
    var o;
    if (void 0 === t) o = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var l = 0;
      (o = new Error(t.replace(/%s/g, function () {
        return String(r[l++]);
      }))).name = "Invariant Violation";
    }
    throw o.framesToPop = 1, o;
  }
}

var invariant_1 = invariant;

function idx(e, t) {
  try {
    return t(e);
  } catch (e) {
    if (e instanceof TypeError) {
      if (nullPattern.test(e)) return null;
      if (undefinedPattern.test(e)) return;
    }

    throw e;
  }
}

var nullPattern = /^null | null$|^[^(]* null /i,
    undefinedPattern = /^undefined | undefined$|^[^(]* undefined /i;
idx.default = idx;
var idx_1 = idx;

function isNil(e) {
  return null == e;
}

var isNil_1 = isNil;

function parsePoint(e) {
  var t = [];
  if (void 0 === e) return t;
  if ("string" == typeof e) t = e.split(",");else if ("number" == typeof e) t = [e];else if (Array.isArray(e)) t = _toConsumableArray(e);else {
    if (null === e || "object" !== _typeof(e)) return t;
    t = [idx_1(e, function (e) {
      return e.x;
    }) || 0, idx_1(e, function (e) {
      return e.y;
    }) || 0];
  }
  return t.filter(function (e) {
    return !isNil_1(e) && !isNaN(e);
  }).map(Number);
}

function isPointType(e) {
  return e instanceof Point || e instanceof ObservablePoint;
}

var eventHandlers = ["click", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "mouseupoutside", "tap", "touchstart", "touchmove", "touchend", "touchendoutside", "pointercancel", "pointerout", "pointerover", "pointertap", "pointerdown", "pointerup", "pointerupoutside", "pointermove", "rightclick", "rightdown", "rightup", "rightupoutside", "touchcancel", "touchendoutside", "touchmove", "touchstart"];

function setValue(e, t, n) {
  if (isPointType(e[t]) && isPointType(n)) e[t].copy(n);else if (isPointType(e[t])) {
    var r = parsePoint(n);
    invariant_1(void 0 !== r && r.length > 0 && r.length < 3, "The property `%s` is a `PIXI.Point` or `PIXI.ObservablePoint` and must be set to a comma-separated string of either 1 or 2 coordinates, a 1 or 2 element array containing coordinates, or a PIXI Point/ObservablePoint. If only one coordinate is given then X and Y will be set to the provided value. Received: `%s` of type `%s`.", t, JSON.stringify(n), _typeof(n)), e[t].set(r.shift(), r.shift());
  } else e[t] = n;
}

var _PROPS_RESERVED,
    isFunction = function isFunction() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
    t[n] = arguments[n];
  }

  return t.reduce(function (e, t) {
    return e && "function" == typeof t;
  }, !0);
},
    isObject = function isObject(e) {
  return "[object Object]" === Object.prototype.toString.call(e);
},
    hasKey = function hasKey(e) {
  var t = e;

  if (!Array.isArray(t)) {
    if (!isObject(e)) throw new Error("collection needs to be an Array or Object");
    t = Object.keys(e);
  }

  return function (e) {
    return -1 !== t.indexOf(e);
  };
},
    not = function not(e) {
  return function () {
    return !e.apply(void 0, arguments);
  };
},
    runningInBrowser = function runningInBrowser() {
  return Boolean(window);
},
    CHILDREN = "children",
    PROPS_RESERVED = (_defineProperty(_PROPS_RESERVED = {}, CHILDREN, !0), _defineProperty(_PROPS_RESERVED, "parent", !0), _defineProperty(_PROPS_RESERVED, "worldAlpha", !0), _defineProperty(_PROPS_RESERVED, "worldTransform", !0), _defineProperty(_PROPS_RESERVED, "worldVisible", !0), _PROPS_RESERVED),
    PROPS_DISPLAY_OBJECT = {
  alpha: 1,
  buttonMode: !1,
  cacheAsBitmap: !1,
  cursor: null,
  filterArea: null,
  filters: null,
  hitArea: null,
  interactive: !1,
  mask: null,
  pivot: 0,
  position: 0,
  renderable: !0,
  rotation: 0,
  scale: 1,
  skew: 0,
  transform: null,
  visible: !0,
  x: 0,
  y: 0
},
    getTextureFromProps = function getTextureFromProps(e, t) {
  var n = t.texture,
      r = void 0 === n ? void 0 : n,
      i = t.image,
      o = void 0 === i ? void 0 : i;
  return o ? (invariant_1("string" == typeof o, e + " image needs to be a string, got `%s`", _typeof(o)), Texture.fromImage(o)) : (invariant_1(r instanceof Texture, e + " texture needs to be typeof `PIXI.Texture`"), r);
};

function applyDefaultProps(e, t, n) {
  if (invariant_1(DisplayObject.prototype.isPrototypeOf(e), "instance needs to be typeof `PIXI.DisplayObject`, got `%s`", _typeof(e)), n.ignoreEvents || eventHandlers.forEach(function (r) {
    isFunction(t[r], e.removeListener) && e.removeListener(r, t[r]), isFunction(n[r], e.on) && e.on(r, n[r]);
  }), n.overwriteProps) for (var r in n) {
    t[r] !== n[r] && setValue(e, r, n[r]);
  } else Object.keys(n || {}).filter(not(hasKey(PROPS_RESERVED))).filter(not(hasKey(eventHandlers))).forEach(function (t) {
    var r = n[t];
    isNil_1(r) ? !isNil_1(e[t]) && t in PROPS_DISPLAY_OBJECT ? (console.warn("setting default value: ".concat(t, ", from: ").concat(e[t], " to: ").concat(r, " for"), e), setValue(e, t, PROPS_DISPLAY_OBJECT[t])) : console.warn("ignoring prop: ".concat(t, ", from ").concat(e[t], " to ").concat(r, " for"), e) : setValue(e, t, r);
  });
}

var BitmapText = function BitmapText(e, t) {
  var n = t.text,
      r = t.style;
  return new extras.BitmapText(n, r);
},
    Container$1 = function Container$1() {
  return new Container();
},
    Graphics$1 = function Graphics$1(e, t) {
  var n = new Graphics();
  return n.applyProps = function (e, t, r) {
    var i = r.draw;
    applyDefaultProps(e, t, _objectWithoutProperties(r, ["draw"])), i && "function" == typeof i && i.call(n, n);
  }, n;
},
    NineSlicePlane = function NineSlicePlane(e, t) {
  var n = t.leftWidth,
      r = void 0 === n ? 10 : n,
      i = t.topHeight,
      o = void 0 === i ? 10 : i,
      l = t.rightWidth,
      a = void 0 === l ? 10 : l,
      u = t.bottomHeight,
      c = void 0 === u ? 10 : u,
      s = getTextureFromProps("NineSlicePlane", t),
      f = new mesh.NineSlicePlane(s, r, o, a, c);
  return f.applyProps = function (e, t, n) {
    var r = n.image,
        i = n.texture;
    applyDefaultProps(e, t, _objectWithoutProperties(n, ["image", "texture"])), (r || i) && (e.texture = getTextureFromProps("NineSlicePlane", n));
  }, f;
},
    ParticleContainer = function ParticleContainer(e, t) {
  var n = t.maxSize,
      r = void 0 === n ? 1500 : n,
      i = t.batchSize,
      o = void 0 === i ? 16384 : i,
      l = t.autoResize,
      a = void 0 !== l && l,
      u = _objectSpread({}, {
    vertices: !1,
    scale: !0,
    position: !0,
    rotation: !0,
    uvs: !0,
    tint: !0
  }, t.properties || {}),
      c = _objectSpread({}, {
    children: !1,
    texture: !1,
    baseTexture: !1
  }, t.destroyOptions || {}),
      s = new particles.ParticleContainer(r, u, o, a);

  return s.willUnmount = function (e, t, n) {
    e.destroy(c);
  }, s;
},
    Sprite$1 = function Sprite$1(e, t) {
  var n = new Sprite(getTextureFromProps("Sprite", t));
  return n.applyProps = function (e, t, n) {
    var r = n.image,
        i = n.texture;
    applyDefaultProps(e, t, _objectWithoutProperties(n, ["image", "texture"])), (i && t.texture !== n.texture || r && t.image !== n.image) && (e.texture = getTextureFromProps("Sprite", n));
  }, n;
},
    Text$1 = function Text$1(e, t) {
  var n = t.text,
      r = void 0 === n ? "" : n,
      i = t.style;
  return new Text(r, void 0 === i ? {} : i);
},
    TilingSprite = function TilingSprite(e, t) {
  var n = t.width,
      r = void 0 === n ? 100 : n,
      i = t.height,
      o = void 0 === i ? 100 : i,
      l = getTextureFromProps("TilingSprite", t),
      a = new extras.TilingSprite(l, r, o);
  return a.applyProps = function (e, t, n) {
    var r,
        i,
        o = n.tileScale,
        l = n.tilePosition,
        a = n.image,
        u = n.texture;
    (applyDefaultProps(e, t, _objectWithoutProperties(n, ["tileScale", "tilePosition", "image", "texture"])), l) && (r = e.tilePosition).set.apply(r, _toConsumableArray(parsePoint(l)));
    o && (i = e.tileScale).set.apply(i, _toConsumableArray(parsePoint(o)));
    (a || u) && (e.texture = getTextureFromProps("Sprite", n));
  }, a;
},
    Mesh = function Mesh(e, t) {
  var n = getTextureFromProps("Mesh", t),
      r = t.vertices,
      i = t.uvs,
      o = t.indices,
      l = t.drawMode,
      a = void 0 === l ? mesh.Mesh.DRAW_MODES.TRIANGLES : l,
      u = new mesh.Mesh(n, r, i, o, a);
  return u.applyProps = function (e, t, n) {
    var r = n.image,
        i = n.texture;
    applyDefaultProps(e, t, _objectWithoutProperties(n, ["image", "texture"])), (r || i) && (e.texture = getTextureFromProps("Mesh", n));
  }, u;
},
    Rope = function Rope(e, t) {
  var n = getTextureFromProps("Rope", t),
      r = t.points,
      i = new mesh.Rope(n, r);
  return i.applyProps = function (e, t, n) {
    var r = n.image,
        i = n.texture,
        o = _objectWithoutProperties(n, ["image", "texture"]);

    invariant_1(Array.isArray(n.points), "Rope points needs to be %s", "Array<PIXI.Point>"), applyDefaultProps(e, t, o), (r || i) && (e.texture = getTextureFromProps("Rope", n));
  }, i;
},
    components = Object.freeze({
  BitmapText: BitmapText,
  Container: Container$1,
  Graphics: Graphics$1,
  NineSlicePlane: NineSlicePlane,
  ParticleContainer: ParticleContainer,
  Sprite: Sprite$1,
  Text: Text$1,
  TilingSprite: TilingSprite,
  Mesh: Mesh,
  Rope: Rope
}),
    TYPES = {
  BitmapText: "BitmapText",
  Container: "Container",
  Graphics: "Graphics",
  NineSlicePlane: "NineSlicePlane",
  ParticleContainer: "ParticleContainer",
  Sprite: "Sprite",
  Text: "Text",
  TilingSprite: "TilingSprite",
  Mesh: "Mesh",
  Rope: "Rope"
},
    ELEMENTS = Object.keys(TYPES).reduce(function (e, t) {
  return _objectSpread({}, e, _defineProperty({}, t, components[t]));
}, {}),
    TYPES_INJECTED = {};

function createElement(e) {
  var t,
      n,
      r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
      o = ELEMENTS[e];

  if ("function" == typeof o && (t = o(i, r)), !t) {
    var l = TYPES_INJECTED[e];
    l && ((t = l.create(r)).didMount = l.didMount ? l.didMount.bind(t) : void 0, t.willUnmount = l.willUnmount ? l.willUnmount.bind(t) : void 0, t.applyProps = l.applyProps ? l.applyProps.bind(t) : void 0);
  }

  return t && ("function" != typeof (n = idx_1(t, function (e) {
    return e.applyProps;
  })) && (n = applyDefaultProps), n(t, {}, r)), t;
}

function PixiComponent(e, t) {
  return invariant_1(!!e, "Expect type to be defined, got `%s`", e), invariant_1(!TYPES[e], "Component `%s` could not be created, already exists in default components.", e), TYPES_INJECTED[e] = t, e;
}

var commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function unwrapExports(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var getOwnPropertySymbols = Object.getOwnPropertySymbols,
    hasOwnProperty = Object.prototype.hasOwnProperty,
    propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

function shouldUseNative() {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, n = 0; n < 10; n++) {
      t["_" + String.fromCharCode(n)] = n;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      r[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (e) {
    return !1;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (e, t) {
  for (var n, r, i = toObject(e), o = 1; o < arguments.length; o++) {
    for (var l in n = Object(arguments[o])) {
      hasOwnProperty.call(n, l) && (i[l] = n[l]);
    }

    if (getOwnPropertySymbols) {
      r = getOwnPropertySymbols(n);

      for (var a = 0; a < r.length; a++) {
        propIsEnumerable.call(n, r[a]) && (i[r[a]] = n[r[a]]);
      }
    }
  }

  return i;
},
    scheduler_production_min = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = null,
      r = !1,
      i = 3,
      o = -1,
      l = -1,
      a = !1,
      u = !1;

  function c() {
    if (!a) {
      var e = n.expirationTime;
      u ? b() : u = !0, _h(p, e);
    }
  }

  function s() {
    var e = n,
        t = n.next;
    if (n === t) n = null;else {
      var r = n.previous;
      n = r.next = t, t.previous = r;
    }
    e.next = e.previous = null, r = e.callback, t = e.expirationTime, e = e.priorityLevel;
    var o = i,
        a = l;
    i = e, l = t;

    try {
      var u = r();
    } finally {
      i = o, l = a;
    }

    if ("function" == typeof u) if (u = {
      callback: u,
      priorityLevel: e,
      expirationTime: t,
      next: null,
      previous: null
    }, null === n) n = u.next = u.previous = u;else {
      r = null, e = n;

      do {
        if (e.expirationTime >= t) {
          r = e;
          break;
        }

        e = e.next;
      } while (e !== n);

      null === r ? r = n : r === n && (n = u, c()), (t = r.previous).next = r.previous = u, u.next = r, u.previous = t;
    }
  }

  function f() {
    if (-1 === o && null !== n && 1 === n.priorityLevel) {
      a = !0;

      try {
        do {
          s();
        } while (null !== n && 1 === n.priorityLevel);
      } finally {
        a = !1, null !== n ? c() : u = !1;
      }
    }
  }

  function p(e) {
    a = !0;
    var i = r;
    r = e;

    try {
      if (e) for (; null !== n;) {
        var o = t.unstable_now();
        if (!(n.expirationTime <= o)) break;

        do {
          s();
        } while (null !== n && n.expirationTime <= o);
      } else if (null !== n) do {
        s();
      } while (null !== n && !y());
    } finally {
      a = !1, r = i, null !== n ? c() : u = !1, f();
    }
  }

  var d,
      m,
      _h,
      b,
      y,
      v = Date,
      g = "function" == typeof setTimeout ? setTimeout : void 0,
      T = "function" == typeof clearTimeout ? clearTimeout : void 0,
      _ = "function" == typeof requestAnimationFrame ? requestAnimationFrame : void 0,
      x = "function" == typeof cancelAnimationFrame ? cancelAnimationFrame : void 0;

  function P(e) {
    d = _(function (t) {
      T(m), e(t);
    }), m = g(function () {
      x(d), e(t.unstable_now());
    }, 100);
  }

  if ("object" == typeof performance && "function" == typeof performance.now) {
    var S = performance;

    t.unstable_now = function () {
      return S.now();
    };
  } else t.unstable_now = function () {
    return v.now();
  };

  if ("undefined" != typeof window && window._schedMock) {
    var C = window._schedMock;
    _h = C[0], b = C[1], y = C[2];
  } else if ("undefined" == typeof window || "function" != typeof window.addEventListener) {
    var E = null,
        w = -1,
        k = function k(e, t) {
      if (null !== E) {
        var n = E;
        E = null;

        try {
          w = t, n(e);
        } finally {
          w = -1;
        }
      }
    };

    _h = function h(e, t) {
      -1 !== w ? setTimeout(_h, 0, e, t) : (E = e, setTimeout(k, t, !0, t), setTimeout(k, 1073741823, !1, 1073741823));
    }, b = function b() {
      E = null;
    }, y = function y() {
      return !1;
    }, t.unstable_now = function () {
      return -1 === w ? 0 : w;
    };
  } else {
    "undefined" != typeof console && ("function" != typeof _ && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" != typeof x && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
    var N = null,
        O = !1,
        I = -1,
        j = !1,
        z = !1,
        R = 0,
        U = 33,
        D = 33;

    y = function y() {
      return R <= t.unstable_now();
    };

    var M = "__reactIdleCallback$" + Math.random().toString(36).slice(2);
    window.addEventListener("message", function (e) {
      if (e.source === window && e.data === M) {
        O = !1, e = N;
        var n = I;
        N = null, I = -1;
        var r = t.unstable_now(),
            i = !1;

        if (0 >= R - r) {
          if (!(-1 !== n && n <= r)) return j || (j = !0, P(A)), N = e, void (I = n);
          i = !0;
        }

        if (null !== e) {
          z = !0;

          try {
            e(i);
          } finally {
            z = !1;
          }
        }
      }
    }, !1);

    var A = function A(e) {
      if (null !== N) {
        P(A);
        var t = e - R + D;
        t < D && U < D ? (8 > t && (t = 8), D = t < U ? U : t) : U = t, R = e + D, O || (O = !0, window.postMessage(M, "*"));
      } else j = !1;
    };

    _h = function _h(e, t) {
      N = e, I = t, z || 0 > t ? window.postMessage(M, "*") : j || (j = !0, P(A));
    }, b = function b() {
      N = null, O = !1, I = -1;
    };
  }

  t.unstable_ImmediatePriority = 1, t.unstable_UserBlockingPriority = 2, t.unstable_NormalPriority = 3, t.unstable_IdlePriority = 5, t.unstable_LowPriority = 4, t.unstable_runWithPriority = function (e, n) {
    switch (e) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;

      default:
        e = 3;
    }

    var r = i,
        l = o;
    i = e, o = t.unstable_now();

    try {
      return n();
    } finally {
      i = r, o = l, f();
    }
  }, t.unstable_scheduleCallback = function (e, r) {
    var l = -1 !== o ? o : t.unstable_now();
    if ("object" == typeof r && null !== r && "number" == typeof r.timeout) r = l + r.timeout;else switch (i) {
      case 1:
        r = l + -1;
        break;

      case 2:
        r = l + 250;
        break;

      case 5:
        r = l + 1073741823;
        break;

      case 4:
        r = l + 1e4;
        break;

      default:
        r = l + 5e3;
    }
    if (e = {
      callback: e,
      priorityLevel: i,
      expirationTime: r,
      next: null,
      previous: null
    }, null === n) n = e.next = e.previous = e, c();else {
      l = null;
      var a = n;

      do {
        if (a.expirationTime > r) {
          l = a;
          break;
        }

        a = a.next;
      } while (a !== n);

      null === l ? l = n : l === n && (n = e, c()), (r = l.previous).next = l.previous = e, e.next = l, e.previous = r;
    }
    return e;
  }, t.unstable_cancelCallback = function (e) {
    var t = e.next;

    if (null !== t) {
      if (t === e) n = null;else {
        e === n && (n = t);
        var r = e.previous;
        r.next = t, t.previous = r;
      }
      e.next = e.previous = null;
    }
  }, t.unstable_wrapCallback = function (e) {
    var n = i;
    return function () {
      var r = i,
          l = o;
      i = n, o = t.unstable_now();

      try {
        return e.apply(this, arguments);
      } finally {
        i = r, o = l, f();
      }
    };
  }, t.unstable_getCurrentPriorityLevel = function () {
    return i;
  }, t.unstable_shouldYield = function () {
    return !r && (null !== n && n.expirationTime < l || y());
  };
});
unwrapExports(scheduler_production_min);
var scheduler_production_min_1 = scheduler_production_min.unstable_now,
    scheduler_production_min_2 = scheduler_production_min.unstable_ImmediatePriority,
    scheduler_production_min_3 = scheduler_production_min.unstable_UserBlockingPriority,
    scheduler_production_min_4 = scheduler_production_min.unstable_NormalPriority,
    scheduler_production_min_5 = scheduler_production_min.unstable_IdlePriority,
    scheduler_production_min_6 = scheduler_production_min.unstable_LowPriority,
    scheduler_production_min_7 = scheduler_production_min.unstable_runWithPriority,
    scheduler_production_min_8 = scheduler_production_min.unstable_scheduleCallback,
    scheduler_production_min_9 = scheduler_production_min.unstable_cancelCallback,
    scheduler_production_min_10 = scheduler_production_min.unstable_wrapCallback,
    scheduler_production_min_11 = scheduler_production_min.unstable_getCurrentPriorityLevel,
    scheduler_production_min_12 = scheduler_production_min.unstable_shouldYield,
    scheduler_development = createCommonjsModule(function (e, t) {});
unwrapExports(scheduler_development);
var scheduler_development_1 = scheduler_development.unstable_now,
    scheduler_development_2 = scheduler_development.unstable_ImmediatePriority,
    scheduler_development_3 = scheduler_development.unstable_UserBlockingPriority,
    scheduler_development_4 = scheduler_development.unstable_NormalPriority,
    scheduler_development_5 = scheduler_development.unstable_IdlePriority,
    scheduler_development_6 = scheduler_development.unstable_LowPriority,
    scheduler_development_7 = scheduler_development.unstable_runWithPriority,
    scheduler_development_8 = scheduler_development.unstable_scheduleCallback,
    scheduler_development_9 = scheduler_development.unstable_cancelCallback,
    scheduler_development_10 = scheduler_development.unstable_wrapCallback,
    scheduler_development_11 = scheduler_development.unstable_getCurrentPriorityLevel,
    scheduler_development_12 = scheduler_development.unstable_shouldYield,
    scheduler = createCommonjsModule(function (e) {
  e.exports = scheduler_production_min;
}),
    reactReconciler_production_min = createCommonjsModule(function (e) {
  e.exports = function t(n) {
    var r = objectAssign,
        i = React,
        o = scheduler;

    function l(e) {
      for (var t = arguments.length - 1, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 0; r < t; r++) {
        n += "&args[]=" + encodeURIComponent(arguments[r + 1]);
      }

      !function (e, t, n, r, i, o, l, a) {
        if (!e) {
          if (e = void 0, void 0 === t) e = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var u = [n, r, i, o, l, a],
                c = 0;
            (e = Error(t.replace(/%s/g, function () {
              return u[c++];
            }))).name = "Invariant Violation";
          }
          throw e.framesToPop = 1, e;
        }
      }(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", n);
    }

    var a = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
        u = "function" == typeof Symbol && Symbol.for,
        c = u ? Symbol.for("react.element") : 60103,
        s = u ? Symbol.for("react.portal") : 60106,
        f = u ? Symbol.for("react.fragment") : 60107,
        p = u ? Symbol.for("react.strict_mode") : 60108,
        d = u ? Symbol.for("react.profiler") : 60114,
        m = u ? Symbol.for("react.provider") : 60109,
        h = u ? Symbol.for("react.context") : 60110,
        b = u ? Symbol.for("react.concurrent_mode") : 60111,
        y = u ? Symbol.for("react.forward_ref") : 60112,
        v = u ? Symbol.for("react.suspense") : 60113,
        g = u ? Symbol.for("react.memo") : 60115,
        T = u ? Symbol.for("react.lazy") : 60116,
        _ = "function" == typeof Symbol && Symbol.iterator;

    function x(e) {
      return null === e || "object" != typeof e ? null : "function" == typeof (e = _ && e[_] || e["@@iterator"]) ? e : null;
    }

    function P(e) {
      if (null == e) return null;
      if ("function" == typeof e) return e.displayName || e.name || null;
      if ("string" == typeof e) return e;

      switch (e) {
        case b:
          return "ConcurrentMode";

        case f:
          return "Fragment";

        case s:
          return "Portal";

        case d:
          return "Profiler";

        case p:
          return "StrictMode";

        case v:
          return "Suspense";
      }

      if ("object" == typeof e) switch (e.$$typeof) {
        case h:
          return "Context.Consumer";

        case m:
          return "Context.Provider";

        case y:
          var t = e.render;
          return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");

        case g:
          return P(e.type);

        case T:
          if (e = 1 === e._status ? e._result : null) return P(e);
      }
      return null;
    }

    function S(e) {
      var t = e;
      if (e.alternate) for (; t.return;) {
        t = t.return;
      } else {
        if (0 != (2 & t.effectTag)) return 1;

        for (; t.return;) {
          if (0 != (2 & (t = t.return).effectTag)) return 1;
        }
      }
      return 3 === t.tag ? 2 : 3;
    }

    function C(e) {
      2 !== S(e) && l("188");
    }

    function E(e) {
      var t = e.alternate;
      if (!t) return 3 === (t = S(e)) && l("188"), 1 === t ? null : e;

      for (var n = e, r = t;;) {
        var i = n.return,
            o = i ? i.alternate : null;
        if (!i || !o) break;

        if (i.child === o.child) {
          for (var a = i.child; a;) {
            if (a === n) return C(i), e;
            if (a === r) return C(i), t;
            a = a.sibling;
          }

          l("188");
        }

        if (n.return !== r.return) n = i, r = o;else {
          a = !1;

          for (var u = i.child; u;) {
            if (u === n) {
              a = !0, n = i, r = o;
              break;
            }

            if (u === r) {
              a = !0, r = i, n = o;
              break;
            }

            u = u.sibling;
          }

          if (!a) {
            for (u = o.child; u;) {
              if (u === n) {
                a = !0, n = o, r = i;
                break;
              }

              if (u === r) {
                a = !0, r = o, n = i;
                break;
              }

              u = u.sibling;
            }

            a || l("189");
          }
        }
        n.alternate !== r && l("190");
      }

      return 3 !== n.tag && l("188"), n.stateNode.current === n ? e : t;
    }

    function w(e) {
      if (!(e = E(e))) return null;

      for (var t = e;;) {
        if (5 === t.tag || 6 === t.tag) return t;
        if (t.child) t.child.return = t, t = t.child;else {
          if (t === e) break;

          for (; !t.sibling;) {
            if (!t.return || t.return === e) return null;
            t = t.return;
          }

          t.sibling.return = t.return, t = t.sibling;
        }
      }

      return null;
    }

    var k = n.getPublicInstance,
        N = n.getRootHostContext,
        O = n.getChildHostContext,
        I = n.prepareForCommit,
        j = n.resetAfterCommit,
        z = n.createInstance,
        R = n.appendInitialChild,
        U = n.finalizeInitialChildren,
        D = n.prepareUpdate,
        M = n.shouldSetTextContent,
        A = n.shouldDeprioritizeSubtree,
        F = n.createTextInstance,
        W = n.scheduleDeferredCallback,
        $ = n.cancelDeferredCallback,
        L = n.shouldYield,
        B = n.setTimeout,
        H = n.clearTimeout,
        Q = n.noTimeout,
        q = n.now,
        V = n.isPrimaryRenderer,
        Y = n.supportsMutation,
        G = n.supportsPersistence,
        X = n.supportsHydration,
        J = n.appendChild,
        K = n.appendChildToContainer,
        Z = n.commitTextUpdate,
        ee = n.commitMount,
        te = n.commitUpdate,
        ne = n.insertBefore,
        re = n.insertInContainerBefore,
        ie = n.removeChild,
        oe = n.removeChildFromContainer,
        le = n.resetTextContent,
        ae = n.hideInstance,
        ue = n.hideTextInstance,
        ce = n.unhideInstance,
        se = n.unhideTextInstance,
        fe = n.cloneInstance,
        pe = n.createContainerChildSet,
        de = n.appendChildToContainerChildSet,
        me = n.finalizeContainerChildren,
        he = n.replaceContainerChildren,
        be = n.cloneHiddenInstance,
        ye = n.cloneUnhiddenInstance,
        ve = n.createHiddenTextInstance,
        ge = n.canHydrateInstance,
        Te = n.canHydrateTextInstance,
        _e = n.getNextHydratableSibling,
        xe = n.getFirstHydratableChild,
        Pe = n.hydrateInstance,
        Se = n.hydrateTextInstance,
        Ce = /^(.*)[\\\/]/;

    function Ee(e) {
      var t = "";

      do {
        e: switch (e.tag) {
          case 2:
          case 16:
          case 0:
          case 1:
          case 5:
          case 8:
          case 13:
            var n = e._debugOwner,
                r = e._debugSource,
                i = P(e.type),
                o = null;
            n && (o = P(n.type)), n = i, i = "", r ? i = " (at " + r.fileName.replace(Ce, "") + ":" + r.lineNumber + ")" : o && (i = " (created by " + o + ")"), o = "\n    in " + (n || "Unknown") + i;
            break e;

          default:
            o = "";
        }

        t += o, e = e.return;
      } while (e);

      return t;
    }

    var we = [],
        ke = -1;

    function Ne(e) {
      0 > ke || (e.current = we[ke], we[ke] = null, ke--);
    }

    function Oe(e, t) {
      we[++ke] = e.current, e.current = t;
    }

    var Ie = {},
        je = {
      current: Ie
    },
        ze = {
      current: !1
    },
        Re = Ie;

    function Ue(e, t) {
      var n = e.type.contextTypes;
      if (!n) return Ie;
      var r = e.stateNode;
      if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
      var i,
          o = {};

      for (i in n) {
        o[i] = t[i];
      }

      return r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = o), o;
    }

    function De(e) {
      return null != (e = e.childContextTypes);
    }

    function Me(e) {
      Ne(ze), Ne(je);
    }

    function Ae(e) {
      Ne(ze), Ne(je);
    }

    function Fe(e, t, n) {
      je.current !== Ie && l("168"), Oe(je, t), Oe(ze, n);
    }

    function We(e, t, n) {
      var i = e.stateNode;
      if (e = t.childContextTypes, "function" != typeof i.getChildContext) return n;

      for (var o in i = i.getChildContext()) {
        o in e || l("108", P(t) || "Unknown", o);
      }

      return r({}, n, i);
    }

    function $e(e) {
      var t = e.stateNode;
      return t = t && t.__reactInternalMemoizedMergedChildContext || Ie, Re = je.current, Oe(je, t), Oe(ze, ze.current), !0;
    }

    function Le(e, t, n) {
      var r = e.stateNode;
      r || l("169"), n ? (t = We(e, t, Re), r.__reactInternalMemoizedMergedChildContext = t, Ne(ze), Ne(je), Oe(je, t)) : Ne(ze), Oe(ze, n);
    }

    var Be = null,
        He = null;

    function Qe(e) {
      return function (t) {
        try {
          return e(t);
        } catch (e) {}
      };
    }

    function qe(e, t, n, r) {
      this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.firstContextDependency = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
    }

    function Ve(e, t, n, r) {
      return new qe(e, t, n, r);
    }

    function Ye(e) {
      return !(!(e = e.prototype) || !e.isReactComponent);
    }

    function Ge(e, t) {
      var n = e.alternate;
      return null === n ? ((n = Ve(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.effectTag = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childExpirationTime = e.childExpirationTime, n.expirationTime = e.expirationTime, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, n.firstContextDependency = e.firstContextDependency, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
    }

    function Xe(e, t, n, r, i, o) {
      var a = 2;
      if (r = e, "function" == typeof e) Ye(e) && (a = 1);else if ("string" == typeof e) a = 5;else e: switch (e) {
        case f:
          return Je(n.children, i, o, t);

        case b:
          return Ke(n, 3 | i, o, t);

        case p:
          return Ke(n, 2 | i, o, t);

        case d:
          return (e = Ve(12, n, t, 4 | i)).elementType = d, e.type = d, e.expirationTime = o, e;

        case v:
          return (e = Ve(13, n, t, i)).elementType = v, e.type = v, e.expirationTime = o, e;

        default:
          if ("object" == typeof e && null !== e) switch (e.$$typeof) {
            case m:
              a = 10;
              break e;

            case h:
              a = 9;
              break e;

            case y:
              a = 11;
              break e;

            case g:
              a = 14;
              break e;

            case T:
              a = 16, r = null;
              break e;
          }
          l("130", null == e ? e : typeof e, "");
      }
      return (t = Ve(a, n, t, i)).elementType = e, t.type = r, t.expirationTime = o, t;
    }

    function Je(e, t, n, r) {
      return (e = Ve(7, e, r, t)).expirationTime = n, e;
    }

    function Ke(e, t, n, r) {
      return e = Ve(8, e, r, t), t = 0 == (1 & t) ? p : b, e.elementType = t, e.type = t, e.expirationTime = n, e;
    }

    function Ze(e, t, n) {
      return (e = Ve(6, e, null, t)).expirationTime = n, e;
    }

    function et(e, t, n) {
      return (t = Ve(4, null !== e.children ? e.children : [], e.key, t)).expirationTime = n, t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
      }, t;
    }

    function tt(e, t) {
      e.didError = !1;
      var n = e.earliestPendingTime;
      0 === n ? e.earliestPendingTime = e.latestPendingTime = t : n < t ? e.earliestPendingTime = t : e.latestPendingTime > t && (e.latestPendingTime = t), it(t, e);
    }

    function nt(e, t) {
      e.didError = !1;
      var n = e.latestPingedTime;
      0 !== n && n >= t && (e.latestPingedTime = 0), n = e.earliestPendingTime;
      var r = e.latestPendingTime;
      n === t ? e.earliestPendingTime = r === t ? e.latestPendingTime = 0 : r : r === t && (e.latestPendingTime = n), n = e.earliestSuspendedTime, r = e.latestSuspendedTime, 0 === n ? e.earliestSuspendedTime = e.latestSuspendedTime = t : n < t ? e.earliestSuspendedTime = t : r > t && (e.latestSuspendedTime = t), it(t, e);
    }

    function rt(e, t) {
      var n = e.earliestPendingTime;
      return n > t && (t = n), (e = e.earliestSuspendedTime) > t && (t = e), t;
    }

    function it(e, t) {
      var n = t.earliestSuspendedTime,
          r = t.latestSuspendedTime,
          i = t.earliestPendingTime,
          o = t.latestPingedTime;
      0 === (i = 0 !== i ? i : o) && (0 === e || r < e) && (i = r), 0 !== (e = i) && n > e && (e = n), t.nextExpirationTimeToWorkOn = i, t.expirationTime = e;
    }

    var ot = !1;

    function lt(e) {
      return {
        baseState: e,
        firstUpdate: null,
        lastUpdate: null,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
      };
    }

    function at(e) {
      return {
        baseState: e.baseState,
        firstUpdate: e.firstUpdate,
        lastUpdate: e.lastUpdate,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
      };
    }

    function ut(e) {
      return {
        expirationTime: e,
        tag: 0,
        payload: null,
        callback: null,
        next: null,
        nextEffect: null
      };
    }

    function ct(e, t) {
      null === e.lastUpdate ? e.firstUpdate = e.lastUpdate = t : (e.lastUpdate.next = t, e.lastUpdate = t);
    }

    function st(e, t) {
      var n = e.alternate;

      if (null === n) {
        var r = e.updateQueue,
            i = null;
        null === r && (r = e.updateQueue = lt(e.memoizedState));
      } else r = e.updateQueue, i = n.updateQueue, null === r ? null === i ? (r = e.updateQueue = lt(e.memoizedState), i = n.updateQueue = lt(n.memoizedState)) : r = e.updateQueue = at(i) : null === i && (i = n.updateQueue = at(r));

      null === i || r === i ? ct(r, t) : null === r.lastUpdate || null === i.lastUpdate ? (ct(r, t), ct(i, t)) : (ct(r, t), i.lastUpdate = t);
    }

    function ft(e, t) {
      var n = e.updateQueue;
      null === (n = null === n ? e.updateQueue = lt(e.memoizedState) : pt(e, n)).lastCapturedUpdate ? n.firstCapturedUpdate = n.lastCapturedUpdate = t : (n.lastCapturedUpdate.next = t, n.lastCapturedUpdate = t);
    }

    function pt(e, t) {
      var n = e.alternate;
      return null !== n && t === n.updateQueue && (t = e.updateQueue = at(t)), t;
    }

    function dt(e, t, n, i, o, l) {
      switch (n.tag) {
        case 1:
          return "function" == typeof (e = n.payload) ? e.call(l, i, o) : e;

        case 3:
          e.effectTag = -2049 & e.effectTag | 64;

        case 0:
          if (null == (o = "function" == typeof (e = n.payload) ? e.call(l, i, o) : e)) break;
          return r({}, i, o);

        case 2:
          ot = !0;
      }

      return i;
    }

    function mt(e, t, n, r, i) {
      ot = !1;

      for (var o = (t = pt(e, t)).baseState, l = null, a = 0, u = t.firstUpdate, c = o; null !== u;) {
        var s = u.expirationTime;
        s < i ? (null === l && (l = u, o = c), a < s && (a = s)) : (c = dt(e, 0, u, c, n, r), null !== u.callback && (e.effectTag |= 32, u.nextEffect = null, null === t.lastEffect ? t.firstEffect = t.lastEffect = u : (t.lastEffect.nextEffect = u, t.lastEffect = u))), u = u.next;
      }

      for (s = null, u = t.firstCapturedUpdate; null !== u;) {
        var f = u.expirationTime;
        f < i ? (null === s && (s = u, null === l && (o = c)), a < f && (a = f)) : (c = dt(e, 0, u, c, n, r), null !== u.callback && (e.effectTag |= 32, u.nextEffect = null, null === t.lastCapturedEffect ? t.firstCapturedEffect = t.lastCapturedEffect = u : (t.lastCapturedEffect.nextEffect = u, t.lastCapturedEffect = u))), u = u.next;
      }

      null === l && (t.lastUpdate = null), null === s ? t.lastCapturedUpdate = null : e.effectTag |= 32, null === l && null === s && (o = c), t.baseState = o, t.firstUpdate = l, t.firstCapturedUpdate = s, e.expirationTime = a, e.memoizedState = c;
    }

    function ht(e, t, n) {
      null !== t.firstCapturedUpdate && (null !== t.lastUpdate && (t.lastUpdate.next = t.firstCapturedUpdate, t.lastUpdate = t.lastCapturedUpdate), t.firstCapturedUpdate = t.lastCapturedUpdate = null), bt(t.firstEffect, n), t.firstEffect = t.lastEffect = null, bt(t.firstCapturedEffect, n), t.firstCapturedEffect = t.lastCapturedEffect = null;
    }

    function bt(e, t) {
      for (; null !== e;) {
        var n = e.callback;

        if (null !== n) {
          e.callback = null;
          var r = t;
          "function" != typeof n && l("191", n), n.call(r);
        }

        e = e.nextEffect;
      }
    }

    function yt(e, t) {
      return {
        value: e,
        source: t,
        stack: Ee(t)
      };
    }

    var vt = {
      current: null
    },
        gt = null,
        Tt = null,
        _t = null;

    function xt(e, t) {
      var n = e.type._context;
      V ? (Oe(vt, n._currentValue), n._currentValue = t) : (Oe(vt, n._currentValue2), n._currentValue2 = t);
    }

    function Pt(e) {
      var t = vt.current;
      Ne(vt), e = e.type._context, V ? e._currentValue = t : e._currentValue2 = t;
    }

    function St(e) {
      gt = e, _t = Tt = null, e.firstContextDependency = null;
    }

    function Ct(e, t) {
      return _t !== e && !1 !== t && 0 !== t && ("number" == typeof t && 1073741823 !== t || (_t = e, t = 1073741823), t = {
        context: e,
        observedBits: t,
        next: null
      }, null === Tt ? (null === gt && l("293"), gt.firstContextDependency = Tt = t) : Tt = Tt.next = t), V ? e._currentValue : e._currentValue2;
    }

    function Et(e, t) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n],
            i = t[n];
        if ((r !== i || 0 === r && 1 / r != 1 / i) && (r == r || i == i)) return !1;
      }

      return !0;
    }

    var wt = 0,
        kt = null,
        Nt = null,
        Ot = null,
        It = null,
        jt = null,
        zt = 0,
        Rt = null,
        Ut = !1,
        Dt = !1,
        Mt = null,
        At = 0;

    function Ft() {
      return null === kt && l("298"), kt;
    }

    function Wt(e, t, n, r) {
      for (; Dt;) {
        Dt = !1, At += 1, Rt = jt = Ot = null, n = e(t, r);
      }

      return Mt = null, At = 0, (e = kt).memoizedState = It, e.expirationTime = zt, e.updateQueue = Rt, e = null !== Ot && null !== Ot.next, wt = 0, jt = It = Ot = Nt = kt = null, zt = 0, Rt = null, e && l("300"), n;
    }

    function $t() {
      wt = 0, jt = It = Ot = Nt = kt = null, zt = 0, Rt = null, Dt = !1, Mt = null, At = 0;
    }

    function Lt(e) {
      return {
        memoizedState: e.memoizedState,
        baseState: e.memoizedState,
        queue: e.queue,
        baseUpdate: e.baseUpdate,
        next: null
      };
    }

    function Bt() {
      if (null === jt) null === It ? (Ut = !1, It = jt = null === (Ot = Nt) ? {
        memoizedState: null,
        baseState: null,
        queue: null,
        baseUpdate: null,
        next: null
      } : Lt(Ot)) : (Ut = !0, Ot = Nt, jt = It);else if (null === jt.next) {
        if (Ut = !1, null === Ot) var e = {
          memoizedState: null,
          baseState: null,
          queue: null,
          baseUpdate: null,
          next: null
        };else e = null === (Ot = Ot.next) ? {
          memoizedState: null,
          baseState: null,
          queue: null,
          baseUpdate: null,
          next: null
        } : Lt(Ot);
        jt = jt.next = e;
      } else Ut = !0, jt = jt.next, Ot = null !== Ot ? Ot.next : null;
      return jt;
    }

    function Ht(e, t) {
      return "function" == typeof t ? t(e) : t;
    }

    function Qt(e, t, n) {
      kt = Ft();
      var r = (jt = Bt()).queue;

      if (null !== r) {
        if (Ut) {
          if (t = r.dispatch, null !== Mt) {
            var i = Mt.get(r);

            if (void 0 !== i) {
              Mt.delete(r), n = jt.memoizedState;

              do {
                n = e(n, i.action), i = i.next;
              } while (null !== i);

              return jt.memoizedState = n, jt.baseUpdate === r.last && (jt.baseState = n), [n, t];
            }
          }

          return [jt.memoizedState, t];
        }

        t = r.last;
        var o = jt.baseUpdate;

        if (null !== o ? (null !== t && (t.next = null), t = o.next) : t = null !== t ? t.next : null, null !== t) {
          n = jt.baseState;
          var a = i = null,
              u = t,
              c = !1;

          do {
            var s = u.expirationTime;
            s < wt ? (c || (c = !0, a = o, i = n), s > zt && (zt = s)) : n = e(n, u.action), o = u, u = u.next;
          } while (null !== u && u !== t);

          c || (a = o, i = n), jt.memoizedState = n, jt.baseUpdate = a, jt.baseState = i;
        }

        return [jt.memoizedState, r.dispatch];
      }

      return e === Ht ? "function" == typeof t && (t = t()) : null != n && (t = e(t, n)), jt.memoizedState = jt.baseState = t, e = (r = jt.queue = {
        last: null,
        dispatch: null
      }).dispatch = function (e, t, n) {
        25 > At || l("301");
        var r = e.alternate;
        if (e === kt || null !== r && r === kt) {
          if (Dt = !0, e = {
            expirationTime: wt,
            action: n,
            next: null
          }, null === Mt && (Mt = new Map()), void 0 === (r = Mt.get(t))) Mt.set(t, e);else {
            for (t = r; null !== t.next;) {
              t = t.next;
            }

            t.next = e;
          }
        } else {
          r = Ir(r = oi(), e), n = {
            expirationTime: r,
            action: n,
            next: null
          }, Er();
          var i = t.last;
          if (null === i) n.next = n;else {
            var o = i.next;
            null !== o && (n.next = o), i.next = n;
          }
          t.last = n, Rr(e, r);
        }
      }.bind(null, kt, r), [jt.memoizedState, e];
    }

    function qt(e, t, n, r) {
      return e = {
        tag: e,
        create: t,
        destroy: n,
        inputs: r,
        next: null
      }, null === Rt ? (Rt = {
        lastEffect: null
      }).lastEffect = e.next = e : null === (t = Rt.lastEffect) ? Rt.lastEffect = e.next = e : (n = t.next, t.next = e, e.next = n, Rt.lastEffect = e), e;
    }

    function Vt(e, t, n, r) {
      kt = Ft(), jt = Bt(), r = null != r ? r : [n];
      var i = null;

      if (null !== Ot) {
        var o = Ot.memoizedState;
        if (i = o.destroy, Et(r, o.inputs)) return void qt(0, n, i, r);
      }

      kt.effectTag |= e, jt.memoizedState = qt(t, n, i, r);
    }

    var Yt = {},
        Gt = {
      current: Yt
    },
        Xt = {
      current: Yt
    },
        Jt = {
      current: Yt
    };

    function Kt(e) {
      return e === Yt && l("174"), e;
    }

    function Zt(e, t) {
      Oe(Jt, t), Oe(Xt, e), Oe(Gt, Yt), t = N(t), Ne(Gt), Oe(Gt, t);
    }

    function en(e) {
      Ne(Gt), Ne(Xt), Ne(Jt);
    }

    function tn() {
      return Kt(Gt.current);
    }

    function nn(e) {
      var t = Kt(Jt.current),
          n = Kt(Gt.current);
      n !== (t = O(n, e.type, t)) && (Oe(Xt, e), Oe(Gt, t));
    }

    function rn(e) {
      Xt.current === e && (Ne(Gt), Ne(Xt));
    }

    var on = Object.prototype.hasOwnProperty;

    function ln(e, t) {
      return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
    }

    function an(e, t) {
      if (ln(e, t)) return !0;
      if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
      var n = Object.keys(e),
          r = Object.keys(t);
      if (n.length !== r.length) return !1;

      for (r = 0; r < n.length; r++) {
        if (!on.call(t, n[r]) || !ln(e[n[r]], t[n[r]])) return !1;
      }

      return !0;
    }

    function un(e, t) {
      if (e && e.defaultProps) for (var n in t = r({}, t), e = e.defaultProps) {
        void 0 === t[n] && (t[n] = e[n]);
      }
      return t;
    }

    var cn = a.ReactCurrentOwner,
        sn = new i.Component().refs;

    function fn(e, t, n, i) {
      n = null == (n = n(i, t = e.memoizedState)) ? t : r({}, t, n), e.memoizedState = n, null !== (i = e.updateQueue) && 0 === e.expirationTime && (i.baseState = n);
    }

    var pn = {
      isMounted: function isMounted(e) {
        return !!(e = e._reactInternalFiber) && 2 === S(e);
      },
      enqueueSetState: function enqueueSetState(e, t, n) {
        e = e._reactInternalFiber;
        var r = oi(),
            i = ut(r = Ir(r, e));
        i.payload = t, null != n && (i.callback = n), Er(), st(e, i), Rr(e, r);
      },
      enqueueReplaceState: function enqueueReplaceState(e, t, n) {
        e = e._reactInternalFiber;
        var r = oi(),
            i = ut(r = Ir(r, e));
        i.tag = 1, i.payload = t, null != n && (i.callback = n), Er(), st(e, i), Rr(e, r);
      },
      enqueueForceUpdate: function enqueueForceUpdate(e, t) {
        e = e._reactInternalFiber;
        var n = oi(),
            r = ut(n = Ir(n, e));
        r.tag = 2, null != t && (r.callback = t), Er(), st(e, r), Rr(e, n);
      }
    };

    function dn(e, t, n, r, i, o, l) {
      return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(r, o, l) : !t.prototype || !t.prototype.isPureReactComponent || !an(n, r) || !an(i, o);
    }

    function mn(e, t, n) {
      var r = !1,
          i = Ie,
          o = t.contextType;
      return "object" == typeof o && null !== o ? o = cn.currentDispatcher.readContext(o) : (i = De(t) ? Re : je.current, o = (r = null != (r = t.contextTypes)) ? Ue(e, i) : Ie), t = new t(n, o), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = pn, e.stateNode = t, t._reactInternalFiber = e, r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = i, e.__reactInternalMemoizedMaskedChildContext = o), t;
    }

    function hn(e, t, n, r) {
      e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && pn.enqueueReplaceState(t, t.state, null);
    }

    function bn(e, t, n, r) {
      var i = e.stateNode;
      i.props = n, i.state = e.memoizedState, i.refs = sn;
      var o = t.contextType;
      "object" == typeof o && null !== o ? i.context = cn.currentDispatcher.readContext(o) : (o = De(t) ? Re : je.current, i.context = Ue(e, o)), null !== (o = e.updateQueue) && (mt(e, o, n, i, r), i.state = e.memoizedState), "function" == typeof (o = t.getDerivedStateFromProps) && (fn(e, t, o, n), i.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof i.getSnapshotBeforeUpdate || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || (t = i.state, "function" == typeof i.componentWillMount && i.componentWillMount(), "function" == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount(), t !== i.state && pn.enqueueReplaceState(i, i.state, null), null !== (o = e.updateQueue) && (mt(e, o, n, i, r), i.state = e.memoizedState)), "function" == typeof i.componentDidMount && (e.effectTag |= 4);
    }

    var yn = Array.isArray;

    function vn(e, t, n) {
      if (null !== (e = n.ref) && "function" != typeof e && "object" != typeof e) {
        if (n._owner) {
          n = n._owner;
          var r = void 0;
          n && (1 !== n.tag && l("289"), r = n.stateNode), r || l("147", e);
          var i = "" + e;
          return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === i ? t.ref : ((t = function t(e) {
            var t = r.refs;
            t === sn && (t = r.refs = {}), null === e ? delete t[i] : t[i] = e;
          })._stringRef = i, t);
        }

        "string" != typeof e && l("284"), n._owner || l("290", e);
      }

      return e;
    }

    function gn(e, t) {
      "textarea" !== e.type && l("31", "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t, "");
    }

    function Tn(e) {
      function t(t, n) {
        if (e) {
          var r = t.lastEffect;
          null !== r ? (r.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.effectTag = 8;
        }
      }

      function n(n, r) {
        if (!e) return null;

        for (; null !== r;) {
          t(n, r), r = r.sibling;
        }

        return null;
      }

      function r(e, t) {
        for (e = new Map(); null !== t;) {
          null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
        }

        return e;
      }

      function i(e, t, n) {
        return (e = Ge(e, t)).index = 0, e.sibling = null, e;
      }

      function o(t, n, r) {
        return t.index = r, e ? null !== (r = t.alternate) ? (r = r.index) < n ? (t.effectTag = 2, n) : r : (t.effectTag = 2, n) : n;
      }

      function a(t) {
        return e && null === t.alternate && (t.effectTag = 2), t;
      }

      function u(e, t, n, r) {
        return null === t || 6 !== t.tag ? ((t = Ze(n, e.mode, r)).return = e, t) : ((t = i(t, n)).return = e, t);
      }

      function p(e, t, n, r) {
        return null !== t && t.elementType === n.type ? ((r = i(t, n.props)).ref = vn(e, t, n), r.return = e, r) : ((r = Xe(n.type, n.key, n.props, null, e.mode, r)).ref = vn(e, t, n), r.return = e, r);
      }

      function d(e, t, n, r) {
        return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = et(n, e.mode, r)).return = e, t) : ((t = i(t, n.children || [])).return = e, t);
      }

      function m(e, t, n, r, o) {
        return null === t || 7 !== t.tag ? ((t = Je(n, e.mode, r, o)).return = e, t) : ((t = i(t, n)).return = e, t);
      }

      function h(e, t, n) {
        if ("string" == typeof t || "number" == typeof t) return (t = Ze("" + t, e.mode, n)).return = e, t;

        if ("object" == typeof t && null !== t) {
          switch (t.$$typeof) {
            case c:
              return (n = Xe(t.type, t.key, t.props, null, e.mode, n)).ref = vn(e, null, t), n.return = e, n;

            case s:
              return (t = et(t, e.mode, n)).return = e, t;
          }

          if (yn(t) || x(t)) return (t = Je(t, e.mode, n, null)).return = e, t;
          gn(e, t);
        }

        return null;
      }

      function b(e, t, n, r) {
        var i = null !== t ? t.key : null;
        if ("string" == typeof n || "number" == typeof n) return null !== i ? null : u(e, t, "" + n, r);

        if ("object" == typeof n && null !== n) {
          switch (n.$$typeof) {
            case c:
              return n.key === i ? n.type === f ? m(e, t, n.props.children, r, i) : p(e, t, n, r) : null;

            case s:
              return n.key === i ? d(e, t, n, r) : null;
          }

          if (yn(n) || x(n)) return null !== i ? null : m(e, t, n, r, null);
          gn(e, n);
        }

        return null;
      }

      function y(e, t, n, r, i) {
        if ("string" == typeof r || "number" == typeof r) return u(t, e = e.get(n) || null, "" + r, i);

        if ("object" == typeof r && null !== r) {
          switch (r.$$typeof) {
            case c:
              return e = e.get(null === r.key ? n : r.key) || null, r.type === f ? m(t, e, r.props.children, i, r.key) : p(t, e, r, i);

            case s:
              return d(t, e = e.get(null === r.key ? n : r.key) || null, r, i);
          }

          if (yn(r) || x(r)) return m(t, e = e.get(n) || null, r, i, null);
          gn(t, r);
        }

        return null;
      }

      function v(i, l, a, u) {
        for (var c = null, s = null, f = l, p = l = 0, d = null; null !== f && p < a.length; p++) {
          f.index > p ? (d = f, f = null) : d = f.sibling;
          var m = b(i, f, a[p], u);

          if (null === m) {
            null === f && (f = d);
            break;
          }

          e && f && null === m.alternate && t(i, f), l = o(m, l, p), null === s ? c = m : s.sibling = m, s = m, f = d;
        }

        if (p === a.length) return n(i, f), c;

        if (null === f) {
          for (; p < a.length; p++) {
            (f = h(i, a[p], u)) && (l = o(f, l, p), null === s ? c = f : s.sibling = f, s = f);
          }

          return c;
        }

        for (f = r(i, f); p < a.length; p++) {
          (d = y(f, i, p, a[p], u)) && (e && null !== d.alternate && f.delete(null === d.key ? p : d.key), l = o(d, l, p), null === s ? c = d : s.sibling = d, s = d);
        }

        return e && f.forEach(function (e) {
          return t(i, e);
        }), c;
      }

      function g(i, a, u, c) {
        var s = x(u);
        "function" != typeof s && l("150"), null == (u = s.call(u)) && l("151");

        for (var f = s = null, p = a, d = a = 0, m = null, v = u.next(); null !== p && !v.done; d++, v = u.next()) {
          p.index > d ? (m = p, p = null) : m = p.sibling;
          var g = b(i, p, v.value, c);

          if (null === g) {
            p || (p = m);
            break;
          }

          e && p && null === g.alternate && t(i, p), a = o(g, a, d), null === f ? s = g : f.sibling = g, f = g, p = m;
        }

        if (v.done) return n(i, p), s;

        if (null === p) {
          for (; !v.done; d++, v = u.next()) {
            null !== (v = h(i, v.value, c)) && (a = o(v, a, d), null === f ? s = v : f.sibling = v, f = v);
          }

          return s;
        }

        for (p = r(i, p); !v.done; d++, v = u.next()) {
          null !== (v = y(p, i, d, v.value, c)) && (e && null !== v.alternate && p.delete(null === v.key ? d : v.key), a = o(v, a, d), null === f ? s = v : f.sibling = v, f = v);
        }

        return e && p.forEach(function (e) {
          return t(i, e);
        }), s;
      }

      return function (e, r, o, u) {
        var p = "object" == typeof o && null !== o && o.type === f && null === o.key;
        p && (o = o.props.children);
        var d = "object" == typeof o && null !== o;
        if (d) switch (o.$$typeof) {
          case c:
            e: {
              for (d = o.key, p = r; null !== p;) {
                if (p.key === d) {
                  if (7 === p.tag ? o.type === f : p.elementType === o.type) {
                    n(e, p.sibling), (r = i(p, o.type === f ? o.props.children : o.props)).ref = vn(e, p, o), r.return = e, e = r;
                    break e;
                  }

                  n(e, p);
                  break;
                }

                t(e, p), p = p.sibling;
              }

              o.type === f ? ((r = Je(o.props.children, e.mode, u, o.key)).return = e, e = r) : ((u = Xe(o.type, o.key, o.props, null, e.mode, u)).ref = vn(e, r, o), u.return = e, e = u);
            }

            return a(e);

          case s:
            e: {
              for (p = o.key; null !== r;) {
                if (r.key === p) {
                  if (4 === r.tag && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
                    n(e, r.sibling), (r = i(r, o.children || [])).return = e, e = r;
                    break e;
                  }

                  n(e, r);
                  break;
                }

                t(e, r), r = r.sibling;
              }

              (r = et(o, e.mode, u)).return = e, e = r;
            }

            return a(e);
        }
        if ("string" == typeof o || "number" == typeof o) return o = "" + o, null !== r && 6 === r.tag ? (n(e, r.sibling), (r = i(r, o)).return = e, e = r) : (n(e, r), (r = Ze(o, e.mode, u)).return = e, e = r), a(e);
        if (yn(o)) return v(e, r, o, u);
        if (x(o)) return g(e, r, o, u);
        if (d && gn(e, o), void 0 === o && !p) switch (e.tag) {
          case 1:
          case 0:
            l("152", (u = e.type).displayName || u.name || "Component");
        }
        return n(e, r);
      };
    }

    var _n = Tn(!0),
        xn = Tn(!1),
        Pn = null,
        Sn = null,
        Cn = !1;

    function En(e, t) {
      var n = Ve(5, null, null, 0);
      n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n.return = e, n.effectTag = 8, null !== e.lastEffect ? (e.lastEffect.nextEffect = n, e.lastEffect = n) : e.firstEffect = e.lastEffect = n;
    }

    function wn(e, t) {
      switch (e.tag) {
        case 5:
          return null !== (t = ge(t, e.type, e.pendingProps)) && (e.stateNode = t, !0);

        case 6:
          return null !== (t = Te(t, e.pendingProps)) && (e.stateNode = t, !0);

        default:
          return !1;
      }
    }

    function kn(e) {
      if (Cn) {
        var t = Sn;

        if (t) {
          var n = t;

          if (!wn(e, t)) {
            if (!(t = _e(n)) || !wn(e, t)) return e.effectTag |= 2, Cn = !1, void (Pn = e);
            En(Pn, n);
          }

          Pn = e, Sn = xe(t);
        } else e.effectTag |= 2, Cn = !1, Pn = e;
      }
    }

    function Nn(e) {
      for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag;) {
        e = e.return;
      }

      Pn = e;
    }

    function On(e) {
      if (!X || e !== Pn) return !1;
      if (!Cn) return Nn(e), Cn = !0, !1;
      var t = e.type;
      if (5 !== e.tag || "head" !== t && "body" !== t && !M(t, e.memoizedProps)) for (t = Sn; t;) {
        En(e, t), t = _e(t);
      }
      return Nn(e), Sn = Pn ? _e(e.stateNode) : null, !0;
    }

    function In() {
      X && (Sn = Pn = null, Cn = !1);
    }

    var jn = a.ReactCurrentOwner;

    function zn(e, t, n, r) {
      t.child = null === e ? xn(t, null, n, r) : _n(t, e.child, n, r);
    }

    function Rn(e, t, n, r, i) {
      n = n.render;
      var o = t.ref;
      St(t), wt = i, kt = t, Nt = null !== e ? e.memoizedState : null;
      var l = n(r, o);
      return l = Wt(n, r, l, o), t.effectTag |= 1, zn(e, t, l, i), t.child;
    }

    function Un(e, t, n, r, i, o) {
      if (null === e) {
        var l = n.type;
        return "function" != typeof l || Ye(l) || void 0 !== l.defaultProps || null !== n.compare ? ((e = Xe(n.type, null, r, null, t.mode, o)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = l, Dn(e, t, l, r, i, o));
      }

      return l = e.child, i < o && (i = l.memoizedProps, (n = null !== (n = n.compare) ? n : an)(i, r) && e.ref === t.ref) ? Bn(e, t, o) : (t.effectTag |= 1, (e = Ge(l, r)).ref = t.ref, e.return = t, t.child = e);
    }

    function Dn(e, t, n, r, i, o) {
      return null !== e && i < o && an(e.memoizedProps, r) && e.ref === t.ref ? Bn(e, t, o) : An(e, t, n, r, o);
    }

    function Mn(e, t) {
      var n = t.ref;
      (null === e && null !== n || null !== e && e.ref !== n) && (t.effectTag |= 128);
    }

    function An(e, t, n, r, i) {
      var o = De(n) ? Re : je.current;
      o = Ue(t, o), St(t), wt = i, kt = t, Nt = null !== e ? e.memoizedState : null;
      var l = n(r, o);
      return l = Wt(n, r, l, o), t.effectTag |= 1, zn(e, t, l, i), t.child;
    }

    function Fn(e, t, n, r, i) {
      if (De(n)) {
        var o = !0;
        $e(t);
      } else o = !1;

      if (St(t), null === t.stateNode) null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), mn(t, n, r), bn(t, n, r, i), r = !0;else if (null === e) {
        var l = t.stateNode,
            a = t.memoizedProps;
        l.props = a;
        var u = l.context,
            c = n.contextType;
        "object" == typeof c && null !== c ? c = cn.currentDispatcher.readContext(c) : c = Ue(t, c = De(n) ? Re : je.current);
        var s = n.getDerivedStateFromProps,
            f = "function" == typeof s || "function" == typeof l.getSnapshotBeforeUpdate;
        f || "function" != typeof l.UNSAFE_componentWillReceiveProps && "function" != typeof l.componentWillReceiveProps || (a !== r || u !== c) && hn(t, l, r, c), ot = !1;
        var p = t.memoizedState;
        u = l.state = p;
        var d = t.updateQueue;
        null !== d && (mt(t, d, r, l, i), u = t.memoizedState), a !== r || p !== u || ze.current || ot ? ("function" == typeof s && (fn(t, n, s, r), u = t.memoizedState), (a = ot || dn(t, n, a, r, p, u, c)) ? (f || "function" != typeof l.UNSAFE_componentWillMount && "function" != typeof l.componentWillMount || ("function" == typeof l.componentWillMount && l.componentWillMount(), "function" == typeof l.UNSAFE_componentWillMount && l.UNSAFE_componentWillMount()), "function" == typeof l.componentDidMount && (t.effectTag |= 4)) : ("function" == typeof l.componentDidMount && (t.effectTag |= 4), t.memoizedProps = r, t.memoizedState = u), l.props = r, l.state = u, l.context = c, r = a) : ("function" == typeof l.componentDidMount && (t.effectTag |= 4), r = !1);
      } else l = t.stateNode, a = t.memoizedProps, l.props = t.type === t.elementType ? a : un(t.type, a), u = l.context, "object" == typeof (c = n.contextType) && null !== c ? c = cn.currentDispatcher.readContext(c) : c = Ue(t, c = De(n) ? Re : je.current), (f = "function" == typeof (s = n.getDerivedStateFromProps) || "function" == typeof l.getSnapshotBeforeUpdate) || "function" != typeof l.UNSAFE_componentWillReceiveProps && "function" != typeof l.componentWillReceiveProps || (a !== r || u !== c) && hn(t, l, r, c), ot = !1, u = t.memoizedState, p = l.state = u, null !== (d = t.updateQueue) && (mt(t, d, r, l, i), p = t.memoizedState), a !== r || u !== p || ze.current || ot ? ("function" == typeof s && (fn(t, n, s, r), p = t.memoizedState), (s = ot || dn(t, n, a, r, u, p, c)) ? (f || "function" != typeof l.UNSAFE_componentWillUpdate && "function" != typeof l.componentWillUpdate || ("function" == typeof l.componentWillUpdate && l.componentWillUpdate(r, p, c), "function" == typeof l.UNSAFE_componentWillUpdate && l.UNSAFE_componentWillUpdate(r, p, c)), "function" == typeof l.componentDidUpdate && (t.effectTag |= 4), "function" == typeof l.getSnapshotBeforeUpdate && (t.effectTag |= 256)) : ("function" != typeof l.componentDidUpdate || a === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 4), "function" != typeof l.getSnapshotBeforeUpdate || a === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 256), t.memoizedProps = r, t.memoizedState = p), l.props = r, l.state = p, l.context = c, r = s) : ("function" != typeof l.componentDidUpdate || a === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 4), "function" != typeof l.getSnapshotBeforeUpdate || a === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 256), r = !1);
      return Wn(e, t, n, r, o, i);
    }

    function Wn(e, t, n, r, i, o) {
      Mn(e, t);
      var l = 0 != (64 & t.effectTag);
      if (!r && !l) return i && Le(t, n, !1), Bn(e, t, o);
      r = t.stateNode, jn.current = t;
      var a = l && "function" != typeof n.getDerivedStateFromError ? null : r.render();
      return t.effectTag |= 1, null !== e && l ? (t.child = _n(t, e.child, null, o), t.child = _n(t, null, a, o)) : zn(e, t, a, o), t.memoizedState = r.state, i && Le(t, n, !0), t.child;
    }

    function $n(e) {
      var t = e.stateNode;
      t.pendingContext ? Fe(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Fe(0, t.context, !1), Zt(e, t.containerInfo);
    }

    function Ln(e, t, n) {
      var r = t.mode,
          i = t.pendingProps,
          o = t.memoizedState;

      if (0 == (64 & t.effectTag)) {
        o = null;
        var l = !1;
      } else o = {
        timedOutAt: null !== o ? o.timedOutAt : 0
      }, l = !0, t.effectTag &= -65;

      return null === e ? l ? (l = i.fallback, i = Je(null, r, 0, null), 0 == (1 & t.mode) && (i.child = null !== t.memoizedState ? t.child.child : t.child), r = Je(l, r, n, null), i.sibling = r, (n = i).return = r.return = t) : n = r = xn(t, null, i.children, n) : null !== e.memoizedState ? (e = (r = e.child).sibling, l ? (n = i.fallback, i = Ge(r, r.pendingProps), 0 == (1 & t.mode) && (l = null !== t.memoizedState ? t.child.child : t.child) !== r.child && (i.child = l), r = i.sibling = Ge(e, n, e.expirationTime), n = i, i.childExpirationTime = 0, n.return = r.return = t) : n = r = _n(t, r.child, i.children, n)) : (e = e.child, l ? (l = i.fallback, (i = Je(null, r, 0, null)).child = e, 0 == (1 & t.mode) && (i.child = null !== t.memoizedState ? t.child.child : t.child), (r = i.sibling = Je(l, r, n, null)).effectTag |= 2, n = i, i.childExpirationTime = 0, n.return = r.return = t) : r = n = _n(t, e, i.children, n)), t.memoizedState = o, t.child = n, r;
    }

    function Bn(e, t, n) {
      if (null !== e && (t.firstContextDependency = e.firstContextDependency), t.childExpirationTime < n) return null;

      if (null !== e && t.child !== e.child && l("153"), null !== t.child) {
        for (n = Ge(e = t.child, e.pendingProps, e.expirationTime), t.child = n, n.return = t; null !== e.sibling;) {
          e = e.sibling, (n = n.sibling = Ge(e, e.pendingProps, e.expirationTime)).return = t;
        }

        n.sibling = null;
      }

      return t.child;
    }

    function Hn(e, t, n) {
      var r = t.expirationTime;

      if (null !== e && e.memoizedProps === t.pendingProps && !ze.current && r < n) {
        switch (t.tag) {
          case 3:
            $n(t), In();
            break;

          case 5:
            nn(t);
            break;

          case 1:
            De(t.type) && $e(t);
            break;

          case 4:
            Zt(t, t.stateNode.containerInfo);
            break;

          case 10:
            xt(t, t.memoizedProps.value);
            break;

          case 13:
            if (null !== t.memoizedState) return 0 !== (r = t.child.childExpirationTime) && r >= n ? Ln(e, t, n) : null !== (t = Bn(e, t, n)) ? t.sibling : null;
        }

        return Bn(e, t, n);
      }

      switch (t.expirationTime = 0, t.tag) {
        case 2:
          r = t.elementType, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps;
          var i = Ue(t, je.current);
          St(t), wt = n, kt = t, Nt = null;
          var o = r(e, i);

          if (t.effectTag |= 1, "object" == typeof o && null !== o && "function" == typeof o.render && void 0 === o.$$typeof) {
            t.tag = 1, $t(), De(r) ? (i = !0, $e(t)) : i = !1, t.memoizedState = null !== o.state && void 0 !== o.state ? o.state : null;
            var a = r.getDerivedStateFromProps;
            "function" == typeof a && fn(t, r, a, e), o.updater = pn, t.stateNode = o, o._reactInternalFiber = t, bn(t, r, e, n), t = Wn(null, t, r, !0, i, n);
          } else t.tag = 0, zn(null, t, o = Wt(r, e, o, i), n), t = t.child;

          return t;

        case 16:
          switch (o = t.elementType, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), i = t.pendingProps, e = function (e) {
            var t = e._result;

            switch (e._status) {
              case 1:
                return t;

              case 2:
              case 0:
                throw t;

              default:
                throw e._status = 0, (t = (t = e._ctor)()).then(function (t) {
                  0 === e._status && (t = t.default, e._status = 1, e._result = t);
                }, function (t) {
                  0 === e._status && (e._status = 2, e._result = t);
                }), e._result = t, t;
            }
          }(o), t.type = e, o = t.tag = function (e) {
            if ("function" == typeof e) return Ye(e) ? 1 : 0;

            if (null != e) {
              if ((e = e.$$typeof) === y) return 11;
              if (e === g) return 14;
            }

            return 2;
          }(e), i = un(e, i), a = void 0, o) {
            case 0:
              a = An(null, t, e, i, n);
              break;

            case 1:
              a = Fn(null, t, e, i, n);
              break;

            case 11:
              a = Rn(null, t, e, i, n);
              break;

            case 14:
              a = Un(null, t, e, un(e.type, i), r, n);
              break;

            default:
              l("283", e);
          }

          return a;

        case 0:
          return r = t.type, o = t.pendingProps, An(e, t, r, o = t.elementType === r ? o : un(r, o), n);

        case 1:
          return r = t.type, o = t.pendingProps, Fn(e, t, r, o = t.elementType === r ? o : un(r, o), n);

        case 3:
          return $n(t), null === (r = t.updateQueue) && l("282"), o = null !== (o = t.memoizedState) ? o.element : null, mt(t, r, t.pendingProps, null, n), (r = t.memoizedState.element) === o ? (In(), t = Bn(e, t, n)) : (o = t.stateNode, (o = (null === e || null === e.child) && o.hydrate) && (X ? (Sn = xe(t.stateNode.containerInfo), Pn = t, o = Cn = !0) : o = !1), o ? (t.effectTag |= 2, t.child = xn(t, null, r, n)) : (zn(e, t, r, n), In()), t = t.child), t;

        case 5:
          return nn(t), null === e && kn(t), r = t.type, o = t.pendingProps, i = null !== e ? e.memoizedProps : null, a = o.children, M(r, o) ? a = null : null !== i && M(r, i) && (t.effectTag |= 16), Mn(e, t), 1 !== n && 1 & t.mode && A(r, o) ? (t.expirationTime = 1, t = null) : (zn(e, t, a, n), t = t.child), t;

        case 6:
          return null === e && kn(t), null;

        case 13:
          return Ln(e, t, n);

        case 4:
          return Zt(t, t.stateNode.containerInfo), r = t.pendingProps, null === e ? t.child = _n(t, null, r, n) : zn(e, t, r, n), t.child;

        case 11:
          return r = t.type, o = t.pendingProps, Rn(e, t, r, o = t.elementType === r ? o : un(r, o), n);

        case 7:
          return zn(e, t, t.pendingProps, n), t.child;

        case 8:
        case 12:
          return zn(e, t, t.pendingProps.children, n), t.child;

        case 10:
          e: {
            if (r = t.type._context, o = t.pendingProps, a = t.memoizedProps, xt(t, i = o.value), null !== a) {
              var u = a.value;

              if (0 === (i = u === i && (0 !== u || 1 / u == 1 / i) || u != u && i != i ? 0 : 0 | ("function" == typeof r._calculateChangedBits ? r._calculateChangedBits(u, i) : 1073741823))) {
                if (a.children === o.children && !ze.current) {
                  t = Bn(e, t, n);
                  break e;
                }
              } else for (null !== (a = t.child) && (a.return = t); null !== a;) {
                if (null !== (u = a.firstContextDependency)) do {
                  if (u.context === r && 0 != (u.observedBits & i)) {
                    if (1 === a.tag) {
                      var c = ut(n);
                      c.tag = 2, st(a, c);
                    }

                    a.expirationTime < n && (a.expirationTime = n), null !== (c = a.alternate) && c.expirationTime < n && (c.expirationTime = n);

                    for (var s = a.return; null !== s;) {
                      if (c = s.alternate, s.childExpirationTime < n) s.childExpirationTime = n, null !== c && c.childExpirationTime < n && (c.childExpirationTime = n);else {
                        if (!(null !== c && c.childExpirationTime < n)) break;
                        c.childExpirationTime = n;
                      }
                      s = s.return;
                    }
                  }

                  c = a.child, u = u.next;
                } while (null !== u);else c = 10 === a.tag && a.type === t.type ? null : a.child;
                if (null !== c) c.return = a;else for (c = a; null !== c;) {
                  if (c === t) {
                    c = null;
                    break;
                  }

                  if (null !== (a = c.sibling)) {
                    a.return = c.return, c = a;
                    break;
                  }

                  c = c.return;
                }
                a = c;
              }
            }

            zn(e, t, o.children, n), t = t.child;
          }

          return t;

        case 9:
          return o = t.type, r = (i = t.pendingProps).children, St(t), r = r(o = Ct(o, i.unstable_observedBits)), t.effectTag |= 1, zn(e, t, r, n), t.child;

        case 14:
          return Un(e, t, o = t.type, i = un(o.type, t.pendingProps), r, n);

        case 15:
          return Dn(e, t, t.type, t.pendingProps, r, n);

        case 17:
          return r = t.type, o = t.pendingProps, o = t.elementType === r ? o : un(r, o), null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), t.tag = 1, De(r) ? (e = !0, $e(t)) : e = !1, St(t), mn(t, r, o), bn(t, r, o, n), Wn(null, t, r, !0, e, n);

        default:
          l("156");
      }
    }

    function Qn(e) {
      e.effectTag |= 4;
    }

    var _qn = void 0,
        Vn = void 0,
        Yn = void 0,
        Gn = void 0;

    if (Y) _qn = function qn(e, t) {
      for (var n = t.child; null !== n;) {
        if (5 === n.tag || 6 === n.tag) R(e, n.stateNode);else if (4 !== n.tag && null !== n.child) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === t) break;

        for (; null === n.sibling;) {
          if (null === n.return || n.return === t) return;
          n = n.return;
        }

        n.sibling.return = n.return, n = n.sibling;
      }
    }, Vn = function Vn() {}, Yn = function Yn(e, t, n, r, i) {
      if ((e = e.memoizedProps) !== r) {
        var o = t.stateNode,
            l = tn();
        n = D(o, n, e, r, i, l), (t.updateQueue = n) && Qn(t);
      }
    }, Gn = function Gn(e, t, n, r) {
      n !== r && Qn(t);
    };else if (G) {
      _qn = function qn(e, t, n, r) {
        for (var i = t.child; null !== i;) {
          e: if (5 === i.tag) {
            var o = i.stateNode;

            if (n) {
              var l = i.memoizedProps,
                  a = i.type;
              o = r ? be(o, a, l, i) : ye(o, a, l, i), i.stateNode = o;
            }

            R(e, o);
          } else if (6 === i.tag) o = i.stateNode, n && (o = i.memoizedProps, l = Kt(Jt.current), a = tn(), o = r ? ve(o, l, a, t) : F(o, l, a, t), i.stateNode = o), R(e, o);else if (4 !== i.tag) {
            if (13 === i.tag && null !== (l = i.alternate) && (o = null !== i.memoizedState, null !== l.memoizedState !== o)) {
              null !== (l = o ? i.child : i) && _qn(e, l, !0, o);
              break e;
            }

            if (null !== i.child) {
              i.child.return = i, i = i.child;
              continue;
            }
          }

          if (i === t) break;

          for (; null === i.sibling;) {
            if (null === i.return || i.return === t) return;
            i = i.return;
          }

          i.sibling.return = i.return, i = i.sibling;
        }
      };

      var Xn = function Xn(e, t, n, r) {
        for (var i = t.child; null !== i;) {
          e: if (5 === i.tag) {
            var o = i.stateNode;

            if (n) {
              var l = i.memoizedProps,
                  a = i.type;
              o = r ? be(o, a, l, i) : ye(o, a, l, i), i.stateNode = o;
            }

            de(e, o);
          } else if (6 === i.tag) o = i.stateNode, n && (o = i.memoizedProps, l = Kt(Jt.current), a = tn(), o = r ? ve(o, l, a, t) : F(o, l, a, t), i.stateNode = o), de(e, o);else if (4 !== i.tag) {
            if (13 === i.tag && null !== (l = i.alternate) && (o = null !== i.memoizedState, null !== l.memoizedState !== o)) {
              null !== (l = o ? i.child : i) && Xn(e, l, !0, o);
              break e;
            }

            if (null !== i.child) {
              i.child.return = i, i = i.child;
              continue;
            }
          }

          if (i === t) break;

          for (; null === i.sibling;) {
            if (null === i.return || i.return === t) return;
            i = i.return;
          }

          i.sibling.return = i.return, i = i.sibling;
        }
      };

      Vn = function Vn(e) {
        var t = e.stateNode;

        if (null !== e.firstEffect) {
          var n = t.containerInfo,
              r = pe(n);
          Xn(r, e, !1, !1), t.pendingChildren = r, Qn(e), me(n, r);
        }
      }, Yn = function Yn(e, t, n, r, i) {
        var o = e.stateNode,
            l = e.memoizedProps;
        if ((e = null === t.firstEffect) && l === r) t.stateNode = o;else {
          var a = t.stateNode,
              u = tn(),
              c = null;
          l !== r && (c = D(a, n, l, r, i, u)), e && null === c ? t.stateNode = o : (o = fe(o, c, n, l, r, t, e, a), U(o, n, r, i, u) && Qn(t), t.stateNode = o, e ? Qn(t) : _qn(o, t, !1, !1));
        }
      }, Gn = function Gn(e, t, n, r) {
        n !== r && (e = Kt(Jt.current), n = tn(), t.stateNode = F(r, e, n, t), Qn(t));
      };
    } else Vn = function Vn() {}, Yn = function Yn() {}, Gn = function Gn() {};

    function Jn(e, t) {
      var n = t.source,
          r = t.stack;
      null === r && null !== n && (r = Ee(n)), null !== n && P(n.type), t = t.value, null !== e && 1 === e.tag && P(e.type);

      try {
        console.error(t);
      } catch (e) {
        setTimeout(function () {
          throw e;
        });
      }
    }

    function Kn(e) {
      var t = e.ref;
      if (null !== t) if ("function" == typeof t) try {
        t(null);
      } catch (t) {
        Or(e, t);
      } else t.current = null;
    }

    function Zn(e, t, n) {
      if (null !== (n = null !== (n = n.updateQueue) ? n.lastEffect : null)) {
        var r = n = n.next;

        do {
          if (0 != (r.tag & e)) {
            var i = r.destroy;
            r.destroy = null, null !== i && i();
          }

          0 != (r.tag & t) && ("function" != typeof (i = (i = r.create)()) && (i = null), r.destroy = i), r = r.next;
        } while (r !== n);
      }
    }

    function er(e) {
      switch ("function" == typeof He && He(e), e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          var t = e.updateQueue;

          if (null !== t && null !== (t = t.lastEffect)) {
            var n = t = t.next;

            do {
              var r = n.destroy;

              if (null !== r) {
                var i = e;

                try {
                  r();
                } catch (e) {
                  Or(i, e);
                }
              }

              n = n.next;
            } while (n !== t);
          }

          break;

        case 1:
          if (Kn(e), "function" == typeof (t = e.stateNode).componentWillUnmount) try {
            t.props = e.memoizedProps, t.state = e.memoizedState, t.componentWillUnmount();
          } catch (t) {
            Or(e, t);
          }
          break;

        case 5:
          Kn(e);
          break;

        case 4:
          Y ? ir(e) : G && G && (e = e.stateNode.containerInfo, t = pe(e), he(e, t));
      }
    }

    function tr(e) {
      for (var t = e;;) {
        if (er(t), null === t.child || Y && 4 === t.tag) {
          if (t === e) break;

          for (; null === t.sibling;) {
            if (null === t.return || t.return === e) return;
            t = t.return;
          }

          t.sibling.return = t.return, t = t.sibling;
        } else t.child.return = t, t = t.child;
      }
    }

    function nr(e) {
      return 5 === e.tag || 3 === e.tag || 4 === e.tag;
    }

    function rr(e) {
      if (Y) {
        e: {
          for (var t = e.return; null !== t;) {
            if (nr(t)) {
              var n = t;
              break e;
            }

            t = t.return;
          }

          l("160"), n = void 0;
        }

        var r = t = void 0;

        switch (n.tag) {
          case 5:
            t = n.stateNode, r = !1;
            break;

          case 3:
          case 4:
            t = n.stateNode.containerInfo, r = !0;
            break;

          default:
            l("161");
        }

        16 & n.effectTag && (le(t), n.effectTag &= -17);

        e: t: for (n = e;;) {
          for (; null === n.sibling;) {
            if (null === n.return || nr(n.return)) {
              n = null;
              break e;
            }

            n = n.return;
          }

          for (n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag;) {
            if (2 & n.effectTag) continue t;
            if (null === n.child || 4 === n.tag) continue t;
            n.child.return = n, n = n.child;
          }

          if (!(2 & n.effectTag)) {
            n = n.stateNode;
            break e;
          }
        }

        for (var i = e;;) {
          if (5 === i.tag || 6 === i.tag) n ? r ? re(t, i.stateNode, n) : ne(t, i.stateNode, n) : r ? K(t, i.stateNode) : J(t, i.stateNode);else if (4 !== i.tag && null !== i.child) {
            i.child.return = i, i = i.child;
            continue;
          }
          if (i === e) break;

          for (; null === i.sibling;) {
            if (null === i.return || i.return === e) return;
            i = i.return;
          }

          i.sibling.return = i.return, i = i.sibling;
        }
      }
    }

    function ir(e) {
      for (var t = e, n = !1, r = void 0, i = void 0;;) {
        if (!n) {
          n = t.return;

          e: for (;;) {
            switch (null === n && l("160"), n.tag) {
              case 5:
                r = n.stateNode, i = !1;
                break e;

              case 3:
              case 4:
                r = n.stateNode.containerInfo, i = !0;
                break e;
            }

            n = n.return;
          }

          n = !0;
        }

        if (5 === t.tag || 6 === t.tag) tr(t), i ? oe(r, t.stateNode) : ie(r, t.stateNode);else if (4 === t.tag ? (r = t.stateNode.containerInfo, i = !0) : er(t), null !== t.child) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break;

        for (; null === t.sibling;) {
          if (null === t.return || t.return === e) return;
          4 === (t = t.return).tag && (n = !1);
        }

        t.sibling.return = t.return, t = t.sibling;
      }
    }

    function or(e, t) {
      if (Y) switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Zn(4, 8, t);
          break;

        case 1:
          break;

        case 5:
          var n = t.stateNode;

          if (null != n) {
            var r = t.memoizedProps;
            e = null !== e ? e.memoizedProps : r;
            var i = t.type,
                o = t.updateQueue;
            t.updateQueue = null, null !== o && te(n, o, i, e, r, t);
          }

          break;

        case 6:
          null === t.stateNode && l("162"), n = t.memoizedProps, Z(t.stateNode, null !== e ? e.memoizedProps : n, n);
          break;

        case 3:
        case 12:
          break;

        case 13:
          if (e = t, null === (r = t.memoizedState) ? n = !1 : (n = !0, e = t.child, 0 === r.timedOutAt && (r.timedOutAt = oi())), null !== e) e: if (t = e, Y) for (r = t;;) {
            if (5 === r.tag) e = r.stateNode, n ? ae(e) : ce(r.stateNode, r.memoizedProps);else if (6 === r.tag) e = r.stateNode, n ? ue(e) : se(e, r.memoizedProps);else {
              if (13 === r.tag && null !== r.memoizedState) {
                (e = r.child.sibling).return = r, r = e;
                continue;
              }

              if (null !== r.child) {
                r.child.return = r, r = r.child;
                continue;
              }
            }
            if (r === t) break e;

            for (; null === r.sibling;) {
              if (null === r.return || r.return === t) break e;
              r = r.return;
            }

            r.sibling.return = r.return, r = r.sibling;
          }
          break;

        case 17:
          break;

        default:
          l("163");
      } else {
        switch (t.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
            return void Zn(4, 8, t);
        }

        if (G) switch (t.tag) {
          case 1:
          case 5:
          case 6:
            break;

          case 3:
          case 4:
            t = t.stateNode, he(t.containerInfo, t.pendingChildren);
            break;

          default:
            l("163");
        }
      }
    }

    function lr(e, t, n) {
      (n = ut(n)).tag = 3, n.payload = {
        element: null
      };
      var r = t.value;
      return n.callback = function () {
        hi(r), Jn(e, t);
      }, n;
    }

    function ar(e, t, n) {
      (n = ut(n)).tag = 3;
      var r = e.type.getDerivedStateFromError;

      if ("function" == typeof r) {
        var i = t.value;

        n.payload = function () {
          return r(i);
        };
      }

      var o = e.stateNode;
      return null !== o && "function" == typeof o.componentDidCatch && (n.callback = function () {
        "function" != typeof r && (null === Sr ? Sr = new Set([this]) : Sr.add(this));
        var n = t.value,
            i = t.stack;
        Jn(e, t), this.componentDidCatch(n, {
          componentStack: null !== i ? i : ""
        });
      }), n;
    }

    function ur(e) {
      switch (e.tag) {
        case 1:
          De(e.type) && Me();
          var t = e.effectTag;
          return 2048 & t ? (e.effectTag = -2049 & t | 64, e) : null;

        case 3:
          return en(), Ae(), 0 != (64 & (t = e.effectTag)) && l("285"), e.effectTag = -2049 & t | 64, e;

        case 5:
          return rn(e), null;

        case 13:
          return 2048 & (t = e.effectTag) ? (e.effectTag = -2049 & t | 64, e) : null;

        case 4:
          return en(), null;

        case 10:
          return Pt(e), null;

        default:
          return null;
      }
    }

    var cr = {
      readContext: Ct,
      useCallback: function useCallback(e, t) {
        kt = Ft(), t = null != t ? t : [e];
        var n = (jt = Bt()).memoizedState;
        return null !== n && Et(t, n[1]) ? n[0] : (jt.memoizedState = [e, t], e);
      },
      useContext: function useContext(e, t) {
        return Ft(), Ct(e, t);
      },
      useEffect: function useEffect(e, t) {
        Vt(516, 192, e, t);
      },
      useImperativeMethods: function useImperativeMethods(e, t, n) {
        Vt(4, 36, function () {
          if ("function" == typeof e) {
            var n = t();
            return e(n), function () {
              return e(null);
            };
          }

          if (null != e) return n = t(), e.current = n, function () {
            e.current = null;
          };
        }, n = null != n ? n.concat([e]) : [e, t]);
      },
      useLayoutEffect: function useLayoutEffect(e, t) {
        Vt(4, 36, e, t);
      },
      useMemo: function useMemo(e, t) {
        kt = Ft(), t = null != t ? t : [e];
        var n = (jt = Bt()).memoizedState;
        return null !== n && Et(t, n[1]) ? n[0] : (e = e(), jt.memoizedState = [e, t], e);
      },
      useMutationEffect: function useMutationEffect(e, t) {
        Vt(260, 10, e, t);
      },
      useReducer: Qt,
      useRef: function useRef(e) {
        return kt = Ft(), null === (jt = Bt()).memoizedState ? (e = {
          current: e
        }, jt.memoizedState = e) : e = jt.memoizedState, e;
      },
      useState: function useState(e) {
        return Qt(Ht, e);
      }
    },
        sr = a.ReactCurrentOwner,
        fr = 1073741822,
        pr = 0,
        dr = !1,
        mr = null,
        hr = null,
        br = 0,
        yr = -1,
        vr = !1,
        gr = null,
        Tr = !1,
        _r = null,
        xr = null,
        Pr = null,
        Sr = null;

    function Cr() {
      if (null !== mr) for (var e = mr.return; null !== e;) {
        var t = e;

        switch (t.tag) {
          case 1:
            var n = t.type.childContextTypes;
            null != n && Me();
            break;

          case 3:
            en(), Ae();
            break;

          case 5:
            rn(t);
            break;

          case 4:
            en();
            break;

          case 10:
            Pt(t);
        }

        e = e.return;
      }
      hr = null, br = 0, yr = -1, vr = !1, mr = null;
    }

    function Er() {
      null !== Pr && (o.unstable_cancelCallback(xr), Pr());
    }

    function wr(e) {
      for (;;) {
        var t = e.alternate,
            n = e.return,
            r = e.sibling;

        if (0 == (1024 & e.effectTag)) {
          mr = e;

          e: {
            var i = t,
                o = br,
                a = (t = e).pendingProps;

            switch (t.tag) {
              case 2:
              case 16:
                break;

              case 15:
              case 0:
                break;

              case 1:
                De(t.type) && Me();
                break;

              case 3:
                en(), Ae(), (a = t.stateNode).pendingContext && (a.context = a.pendingContext, a.pendingContext = null), null !== i && null !== i.child || (On(t), t.effectTag &= -3), Vn(t);
                break;

              case 5:
                rn(t), o = Kt(Jt.current);
                var u = t.type;
                if (null !== i && null != t.stateNode) Yn(i, t, u, a, o), i.ref !== t.ref && (t.effectTag |= 128);else if (a) {
                  if (i = tn(), On(t)) a = t, X || l("175"), i = Pe(a.stateNode, a.type, a.memoizedProps, o, i, a), a.updateQueue = i, (i = null !== i) && Qn(t);else {
                    var c = z(u, a, o, i, t);
                    _qn(c, t, !1, !1), U(c, u, a, o, i) && Qn(t), t.stateNode = c;
                  }
                  null !== t.ref && (t.effectTag |= 128);
                } else null === t.stateNode && l("166");
                break;

              case 6:
                i && null != t.stateNode ? Gn(i, t, i.memoizedProps, a) : ("string" != typeof a && null === t.stateNode && l("166"), i = Kt(Jt.current), o = tn(), On(t) ? (i = t, X || l("176"), (i = Se(i.stateNode, i.memoizedProps, i)) && Qn(t)) : t.stateNode = F(a, i, o, t));
                break;

              case 11:
                break;

              case 13:
                if (a = t.memoizedState, 0 != (64 & t.effectTag)) {
                  t.expirationTime = o, mr = t;
                  break e;
                }

                a = null !== a, o = null !== i && null !== i.memoizedState, null !== i && !a && o && null !== (i = i.child.sibling) && (null !== (u = t.firstEffect) ? (t.firstEffect = i, i.nextEffect = u) : (t.firstEffect = t.lastEffect = i, i.nextEffect = null), i.effectTag = 8), (a !== o || 0 == (1 & t.effectTag) && a) && (t.effectTag |= 4);
                break;

              case 7:
              case 8:
              case 12:
                break;

              case 4:
                en(), Vn(t);
                break;

              case 10:
                Pt(t);
                break;

              case 9:
              case 14:
                break;

              case 17:
                De(t.type) && Me();
                break;

              default:
                l("156");
            }

            mr = null;
          }

          if (t = e, 1 === br || 1 !== t.childExpirationTime) {
            for (i = 0, a = t.child; null !== a;) {
              (o = a.expirationTime) > i && (i = o), (u = a.childExpirationTime) > i && (i = u), a = a.sibling;
            }

            t.childExpirationTime = i;
          }

          if (null !== mr) return mr;
          null !== n && 0 == (1024 & n.effectTag) && (null === n.firstEffect && (n.firstEffect = e.firstEffect), null !== e.lastEffect && (null !== n.lastEffect && (n.lastEffect.nextEffect = e.firstEffect), n.lastEffect = e.lastEffect), 1 < e.effectTag && (null !== n.lastEffect ? n.lastEffect.nextEffect = e : n.firstEffect = e, n.lastEffect = e));
        } else {
          if (null !== (e = ur(e))) return e.effectTag &= 1023, e;
          null !== n && (n.firstEffect = n.lastEffect = null, n.effectTag |= 1024);
        }

        if (null !== r) return r;
        if (null === n) break;
        e = n;
      }

      return null;
    }

    function kr(e) {
      var t = Hn(e.alternate, e, br);
      return e.memoizedProps = e.pendingProps, null === t && (t = wr(e)), sr.current = null, t;
    }

    function Nr(e, t) {
      dr && l("243"), Er(), dr = !0, sr.currentDispatcher = cr;
      var n = e.nextExpirationTimeToWorkOn;
      n === br && e === hr && null !== mr || (Cr(), br = n, mr = Ge((hr = e).current, null), e.pendingCommitExpirationTime = 0);

      for (var r = !1;;) {
        try {
          if (t) for (; null !== mr && !ci();) {
            mr = kr(mr);
          } else for (; null !== mr;) {
            mr = kr(mr);
          }
        } catch (t) {
          if (_t = Tt = gt = null, $t(), null === mr) r = !0, hi(t);else {
            null === mr && l("271");
            var i = mr,
                o = i.return;

            if (null !== o) {
              e: {
                var a = e,
                    u = o,
                    c = i,
                    s = t;

                if (o = br, c.effectTag |= 1024, c.firstEffect = c.lastEffect = null, null !== s && "object" == typeof s && "function" == typeof s.then) {
                  var f = s;
                  s = u;
                  var p = -1,
                      d = -1;

                  do {
                    if (13 === s.tag) {
                      var m = s.alternate;

                      if (null !== m && null !== (m = m.memoizedState)) {
                        d = 10 * (1073741822 - m.timedOutAt);
                        break;
                      }

                      "number" == typeof (m = s.pendingProps.maxDuration) && (0 >= m ? p = 0 : (-1 === p || m < p) && (p = m));
                    }

                    s = s.return;
                  } while (null !== s);

                  s = u;

                  do {
                    if ((m = 13 === s.tag) && (m = void 0 !== s.memoizedProps.fallback && null === s.memoizedState), m) {
                      if (u = jr.bind(null, a, s, c, 0 == (1 & s.mode) ? 1073741823 : o), f.then(u, u), 0 == (1 & s.mode)) {
                        s.effectTag |= 64, c.effectTag &= -1957, 1 === c.tag && null === c.alternate && (c.tag = 17), c.expirationTime = o;
                        break e;
                      }

                      -1 === p ? a = 1073741823 : (-1 === d && (d = 10 * (1073741822 - rt(a, o)) - 5e3), a = d + p), 0 <= a && yr < a && (yr = a), s.effectTag |= 2048, s.expirationTime = o;
                      break e;
                    }

                    s = s.return;
                  } while (null !== s);

                  s = Error((P(c.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + Ee(c));
                }

                vr = !0, s = yt(s, c), a = u;

                do {
                  switch (a.tag) {
                    case 3:
                      c = s, a.effectTag |= 2048, a.expirationTime = o, ft(a, o = lr(a, c, o));
                      break e;

                    case 1:
                      if (c = s, u = a.type, f = a.stateNode, 0 == (64 & a.effectTag) && ("function" == typeof u.getDerivedStateFromError || null !== f && "function" == typeof f.componentDidCatch && (null === Sr || !Sr.has(f)))) {
                        a.effectTag |= 2048, a.expirationTime = o, ft(a, o = ar(a, c, o));
                        break e;
                      }

                  }

                  a = a.return;
                } while (null !== a);
              }

              mr = wr(i);
              continue;
            }

            r = !0, hi(t);
          }
        }

        break;
      }

      if (dr = !1, _t = Tt = gt = sr.currentDispatcher = null, $t(), r) hr = null, e.finishedWork = null;else if (null !== mr) e.finishedWork = null;else {
        if (null === (r = e.current.alternate) && l("281"), hr = null, vr) {
          if (i = e.latestPendingTime, o = e.latestSuspendedTime, a = e.latestPingedTime, 0 !== i && i < n || 0 !== o && o < n || 0 !== a && a < n) return nt(e, n), void ii(e, r, n, e.expirationTime, -1);
          if (!e.didError && t) return e.didError = !0, n = e.nextExpirationTimeToWorkOn = n, t = e.expirationTime = 1073741823, void ii(e, r, n, t, -1);
        }

        t && -1 !== yr ? (nt(e, n), (t = 10 * (1073741822 - rt(e, n))) < yr && (yr = t), t = 10 * (1073741822 - oi()), t = yr - t, ii(e, r, n, e.expirationTime, 0 > t ? 0 : t)) : (e.pendingCommitExpirationTime = n, e.finishedWork = r);
      }
    }

    function Or(e, t) {
      for (var n = e.return; null !== n;) {
        switch (n.tag) {
          case 1:
            var r = n.stateNode;
            if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof r.componentDidCatch && (null === Sr || !Sr.has(r))) return st(n, e = ar(n, e = yt(t, e), 1073741823)), void Rr(n, 1073741823);
            break;

          case 3:
            return st(n, e = lr(n, e = yt(t, e), 1073741823)), void Rr(n, 1073741823);
        }

        n = n.return;
      }

      3 === e.tag && (st(e, n = lr(e, n = yt(t, e), 1073741823)), Rr(e, 1073741823));
    }

    function Ir(e, t) {
      return 0 !== pr ? e = pr : dr ? e = Tr ? 1073741823 : br : 1 & t.mode ? (e = Yr ? 1073741822 - 10 * (1 + ((1073741822 - e + 15) / 10 | 0)) : 1073741822 - 25 * (1 + ((1073741822 - e + 500) / 25 | 0)), null !== hr && e === br && --e) : e = 1073741823, Yr && (0 === Br || e < Br) && (Br = e), e;
    }

    function jr(e, t, n, r) {
      var i = e.earliestSuspendedTime,
          o = e.latestSuspendedTime;

      if (0 !== i && r <= i && r >= o) {
        o = i = r, e.didError = !1;
        var l = e.latestPingedTime;
        (0 === l || l > o) && (e.latestPingedTime = o), it(o, e);
      } else tt(e, i = Ir(i = oi(), t));

      0 != (1 & t.mode) && e === hr && br === r && (hr = null), zr(t, i), 0 == (1 & t.mode) && (zr(n, i), 1 === n.tag && null !== n.stateNode && ((t = ut(i)).tag = 2, st(n, t))), 0 !== (n = e.expirationTime) && li(e, n);
    }

    function zr(e, t) {
      e.expirationTime < t && (e.expirationTime = t);
      var n = e.alternate;
      null !== n && n.expirationTime < t && (n.expirationTime = t);
      var r = e.return,
          i = null;
      if (null === r && 3 === e.tag) i = e.stateNode;else for (; null !== r;) {
        if (n = r.alternate, r.childExpirationTime < t && (r.childExpirationTime = t), null !== n && n.childExpirationTime < t && (n.childExpirationTime = t), null === r.return && 3 === r.tag) {
          i = r.stateNode;
          break;
        }

        r = r.return;
      }
      return i;
    }

    function Rr(e, t) {
      null !== (e = zr(e, t)) && (!dr && 0 !== br && t > br && Cr(), tt(e, t), dr && !Tr && hr === e || li(e, e.expirationTime), ei > Zr && (ei = 0, l("185")));
    }

    function Ur(e, t, n, r, i) {
      var o = pr;
      pr = 1073741823;

      try {
        return e(t, n, r, i);
      } finally {
        pr = o;
      }
    }

    var Dr = null,
        Mr = null,
        Ar = 0,
        Fr = void 0,
        Wr = !1,
        $r = null,
        Lr = 0,
        Br = 0,
        Hr = !1,
        Qr = null,
        qr = !1,
        Vr = !1,
        Yr = !1,
        Gr = null,
        Xr = q(),
        Jr = 1073741822 - (Xr / 10 | 0),
        Kr = Jr,
        Zr = 50,
        ei = 0,
        ti = null;

    function ni() {
      Jr = 1073741822 - ((q() - Xr) / 10 | 0);
    }

    function ri(e, t) {
      if (0 !== Ar) {
        if (t < Ar) return;
        null !== Fr && $(Fr);
      }

      Ar = t, e = q() - Xr, Fr = W(si, {
        timeout: 10 * (1073741822 - t) - e
      });
    }

    function ii(e, t, n, r, i) {
      e.expirationTime = r, 0 !== i || ci() ? 0 < i && (e.timeoutHandle = B(function (e, t, n) {
        e.pendingCommitExpirationTime = n, e.finishedWork = t, ni(), Kr = Jr, pi(e, n);
      }.bind(null, e, t, n), i)) : (e.pendingCommitExpirationTime = n, e.finishedWork = t);
    }

    function oi() {
      return Wr ? Kr : (ai(), 0 !== Lr && 1 !== Lr || (ni(), Kr = Jr), Kr);
    }

    function li(e, t) {
      null === e.nextScheduledRoot ? (e.expirationTime = t, null === Mr ? (Dr = Mr = e, e.nextScheduledRoot = e) : (Mr = Mr.nextScheduledRoot = e).nextScheduledRoot = Dr) : t > e.expirationTime && (e.expirationTime = t), Wr || (qr ? Vr && ($r = e, Lr = 1073741823, di(e, 1073741823, !1)) : 1073741823 === t ? fi(1073741823, !1) : ri(e, t));
    }

    function ai() {
      var e = 0,
          t = null;
      if (null !== Mr) for (var n = Mr, r = Dr; null !== r;) {
        var i = r.expirationTime;

        if (0 === i) {
          if ((null === n || null === Mr) && l("244"), r === r.nextScheduledRoot) {
            Dr = Mr = r.nextScheduledRoot = null;
            break;
          }

          if (r === Dr) Dr = i = r.nextScheduledRoot, Mr.nextScheduledRoot = i, r.nextScheduledRoot = null;else {
            if (r === Mr) {
              (Mr = n).nextScheduledRoot = Dr, r.nextScheduledRoot = null;
              break;
            }

            n.nextScheduledRoot = r.nextScheduledRoot, r.nextScheduledRoot = null;
          }
          r = n.nextScheduledRoot;
        } else {
          if (i > e && (e = i, t = r), r === Mr) break;
          if (1073741823 === e) break;
          n = r, r = r.nextScheduledRoot;
        }
      }
      $r = t, Lr = e;
    }

    var ui = !1;

    function ci() {
      return !!ui || !!L() && (ui = !0);
    }

    function si() {
      try {
        if (!ci() && null !== Dr) {
          ni();
          var e = Dr;

          do {
            var t = e.expirationTime;
            0 !== t && Jr <= t && (e.nextExpirationTimeToWorkOn = Jr), e = e.nextScheduledRoot;
          } while (e !== Dr);
        }

        fi(0, !0);
      } finally {
        ui = !1;
      }
    }

    function fi(e, t) {
      if (ai(), t) for (ni(), Kr = Jr; null !== $r && 0 !== Lr && e <= Lr && !(ui && Jr > Lr);) {
        di($r, Lr, Jr > Lr), ai(), ni(), Kr = Jr;
      } else for (; null !== $r && 0 !== Lr && e <= Lr;) {
        di($r, Lr, !1), ai();
      }
      if (t && (Ar = 0, Fr = null), 0 !== Lr && ri($r, Lr), ei = 0, ti = null, null !== Gr) for (e = Gr, Gr = null, t = 0; t < e.length; t++) {
        var n = e[t];

        try {
          n._onComplete();
        } catch (e) {
          Hr || (Hr = !0, Qr = e);
        }
      }
      if (Hr) throw e = Qr, Qr = null, Hr = !1, e;
    }

    function pi(e, t) {
      Wr && l("253"), $r = e, Lr = t, di(e, t, !1), fi(1073741823, !1);
    }

    function di(e, t, n) {
      if (Wr && l("245"), Wr = !0, n) {
        var r = e.finishedWork;
        null !== r ? mi(e, r, t) : (e.finishedWork = null, (r = e.timeoutHandle) !== Q && (e.timeoutHandle = Q, H(r)), Nr(e, n), null !== (r = e.finishedWork) && (ci() ? e.finishedWork = r : mi(e, r, t)));
      } else null !== (r = e.finishedWork) ? mi(e, r, t) : (e.finishedWork = null, (r = e.timeoutHandle) !== Q && (e.timeoutHandle = Q, H(r)), Nr(e, n), null !== (r = e.finishedWork) && mi(e, r, t));

      Wr = !1;
    }

    function mi(e, t, n) {
      var r = e.firstBatch;
      if (null !== r && r._expirationTime >= n && (null === Gr ? Gr = [r] : Gr.push(r), r._defer)) return e.finishedWork = t, void (e.expirationTime = 0);
      e.finishedWork = null, e === ti ? ei++ : (ti = e, ei = 0), Tr = dr = !0, e.current === t && l("177"), 0 === (n = e.pendingCommitExpirationTime) && l("261"), e.pendingCommitExpirationTime = 0, r = t.expirationTime;
      var i = t.childExpirationTime;

      for (r = i > r ? i : r, e.didError = !1, 0 === r ? (e.earliestPendingTime = 0, e.latestPendingTime = 0, e.earliestSuspendedTime = 0, e.latestSuspendedTime = 0, e.latestPingedTime = 0) : (0 !== (i = e.latestPendingTime) && (i > r ? e.earliestPendingTime = e.latestPendingTime = 0 : e.earliestPendingTime > r && (e.earliestPendingTime = e.latestPendingTime)), 0 === (i = e.earliestSuspendedTime) ? tt(e, r) : r < e.latestSuspendedTime ? (e.earliestSuspendedTime = 0, e.latestSuspendedTime = 0, e.latestPingedTime = 0, tt(e, r)) : r > i && tt(e, r)), it(0, e), sr.current = null, 1 < t.effectTag ? null !== t.lastEffect ? (t.lastEffect.nextEffect = t, r = t.firstEffect) : r = t : r = t.firstEffect, I(e.containerInfo), gr = r; null !== gr;) {
        i = !1;
        var a = void 0;

        try {
          for (; null !== gr;) {
            if (256 & gr.effectTag) e: {
              var u = gr.alternate,
                  c = gr;

              switch (c.tag) {
                case 0:
                case 11:
                case 15:
                  Zn(2, 0, c);
                  break e;

                case 1:
                  if (256 & c.effectTag && null !== u) {
                    var s = u.memoizedProps,
                        f = u.memoizedState,
                        p = c.stateNode,
                        d = p.getSnapshotBeforeUpdate(c.elementType === c.type ? s : un(c.type, s), f);
                    p.__reactInternalSnapshotBeforeUpdate = d;
                  }

                  break e;

                case 3:
                case 5:
                case 6:
                case 4:
                case 17:
                  break e;

                default:
                  l("163");
              }
            }
            gr = gr.nextEffect;
          }
        } catch (e) {
          i = !0, a = e;
        }

        i && (null === gr && l("178"), Or(gr, a), null !== gr && (gr = gr.nextEffect));
      }

      for (gr = r; null !== gr;) {
        u = !1, s = void 0;

        try {
          for (; null !== gr;) {
            var m = gr.effectTag;

            if (16 & m && Y && le(gr.stateNode), 128 & m) {
              var h = gr.alternate;

              if (null !== h) {
                var b = h.ref;
                null !== b && ("function" == typeof b ? b(null) : b.current = null);
              }
            }

            switch (14 & m) {
              case 2:
                rr(gr), gr.effectTag &= -3;
                break;

              case 6:
                rr(gr), gr.effectTag &= -3, or(gr.alternate, gr);
                break;

              case 4:
                or(gr.alternate, gr);
                break;

              case 8:
                f = gr, Y ? ir(f) : tr(f), f.return = null, f.child = null, f.alternate && (f.alternate.child = null, f.alternate.return = null);
            }

            gr = gr.nextEffect;
          }
        } catch (e) {
          u = !0, s = e;
        }

        u && (null === gr && l("178"), Or(gr, s), null !== gr && (gr = gr.nextEffect));
      }

      for (j(e.containerInfo), e.current = t, gr = r; null !== gr;) {
        m = !1, h = void 0;

        try {
          for (b = e, u = n; null !== gr;) {
            var y = gr.effectTag;

            if (36 & y) {
              var v = gr.alternate;

              switch (f = u, (s = gr).tag) {
                case 0:
                case 11:
                case 15:
                  Zn(16, 32, s);
                  break;

                case 1:
                  var g = s.stateNode;
                  if (4 & s.effectTag) if (null === v) g.componentDidMount();else {
                    var T = s.elementType === s.type ? v.memoizedProps : un(s.type, v.memoizedProps);
                    g.componentDidUpdate(T, v.memoizedState, g.__reactInternalSnapshotBeforeUpdate);
                  }
                  var _ = s.updateQueue;
                  null !== _ && ht(0, _, g);
                  break;

                case 3:
                  var x = s.updateQueue;

                  if (null !== x) {
                    if (p = null, null !== s.child) switch (s.child.tag) {
                      case 5:
                        p = k(s.child.stateNode);
                        break;

                      case 1:
                        p = s.child.stateNode;
                    }
                    ht(0, x, p);
                  }

                  break;

                case 5:
                  var P = s.stateNode;
                  null === v && 4 & s.effectTag && ee(P, s.type, s.memoizedProps, s);
                  break;

                case 6:
                case 4:
                case 12:
                case 13:
                case 17:
                  break;

                default:
                  l("163");
              }
            }

            if (128 & y) {
              var S = gr.ref;

              if (null !== S) {
                var C = gr.stateNode;

                switch (gr.tag) {
                  case 5:
                    var E = k(C);
                    break;

                  default:
                    E = C;
                }

                "function" == typeof S ? S(E) : S.current = E;
              }
            }

            512 & y && (_r = b), gr = gr.nextEffect;
          }
        } catch (e) {
          m = !0, h = e;
        }

        m && (null === gr && l("178"), Or(gr, h), null !== gr && (gr = gr.nextEffect));
      }

      null !== r && null !== _r && (y = function (e, t) {
        Pr = xr = _r = null;
        var n = Wr;
        Wr = !0;

        do {
          if (512 & t.effectTag) {
            var r = !1,
                i = void 0;

            try {
              var o = t;
              Zn(128, 0, o), Zn(0, 64, o);
            } catch (e) {
              r = !0, i = e;
            }

            r && Or(t, i);
          }

          t = t.nextEffect;
        } while (null !== t);

        Wr = n, 0 !== (n = e.expirationTime) && li(e, n);
      }.bind(null, e, r), xr = o.unstable_scheduleCallback(y), Pr = y), dr = Tr = !1, "function" == typeof Be && Be(t.stateNode), y = t.expirationTime, 0 === (t = (t = t.childExpirationTime) > y ? t : y) && (Sr = null), e.expirationTime = t, e.finishedWork = null;
    }

    function hi(e) {
      null === $r && l("246"), $r.expirationTime = 0, Hr || (Hr = !0, Qr = e);
    }

    function bi(e, t, n, r, i) {
      var o = t.current;

      e: if (n) {
        t: {
          2 === S(n = n._reactInternalFiber) && 1 === n.tag || l("170");
          var a = n;

          do {
            switch (a.tag) {
              case 3:
                a = a.stateNode.context;
                break t;

              case 1:
                if (De(a.type)) {
                  a = a.stateNode.__reactInternalMemoizedMergedChildContext;
                  break t;
                }

            }

            a = a.return;
          } while (null !== a);

          l("171"), a = void 0;
        }

        if (1 === n.tag) {
          var u = n.type;

          if (De(u)) {
            n = We(n, u, a);
            break e;
          }
        }

        n = a;
      } else n = Ie;

      return null === t.context ? t.context = n : t.pendingContext = n, t = i, (i = ut(r)).payload = {
        element: e
      }, null !== (t = void 0 === t ? null : t) && (i.callback = t), Er(), st(o, i), Rr(o, r), r;
    }

    function yi(e) {
      var t = e._reactInternalFiber;
      return void 0 === t && ("function" == typeof e.render ? l("188") : l("268", Object.keys(e))), null === (e = w(t)) ? null : e.stateNode;
    }

    var vi = {
      updateContainerAtExpirationTime: bi,
      createContainer: function createContainer(e, t, n) {
        return e = {
          current: t = Ve(3, null, null, t ? 3 : 0),
          containerInfo: e,
          pendingChildren: null,
          earliestPendingTime: 0,
          latestPendingTime: 0,
          earliestSuspendedTime: 0,
          latestSuspendedTime: 0,
          latestPingedTime: 0,
          didError: !1,
          pendingCommitExpirationTime: 0,
          finishedWork: null,
          timeoutHandle: Q,
          context: null,
          pendingContext: null,
          hydrate: n,
          nextExpirationTimeToWorkOn: 0,
          expirationTime: 0,
          firstBatch: null,
          nextScheduledRoot: null
        }, t.stateNode = e;
      },
      updateContainer: function updateContainer(e, t, n, r) {
        var i = t.current;
        return bi(e, t, n, i = Ir(oi(), i), r);
      },
      flushRoot: pi,
      requestWork: li,
      computeUniqueAsyncExpiration: function computeUniqueAsyncExpiration() {
        var e = 1073741822 - 25 * (1 + ((1073741822 - oi() + 500) / 25 | 0));
        return e >= fr && (e = fr - 1), fr = e;
      },
      batchedUpdates: function batchedUpdates(e, t) {
        var n = qr;
        qr = !0;

        try {
          return e(t);
        } finally {
          (qr = n) || Wr || fi(1073741823, !1);
        }
      },
      unbatchedUpdates: function unbatchedUpdates(e, t) {
        if (qr && !Vr) {
          Vr = !0;

          try {
            return e(t);
          } finally {
            Vr = !1;
          }
        }

        return e(t);
      },
      deferredUpdates: function deferredUpdates(e) {
        var t = oi(),
            n = pr,
            r = Yr;
        pr = 1073741822 - 25 * (1 + ((1073741822 - t + 500) / 25 | 0)), Yr = !1;

        try {
          return e();
        } finally {
          pr = n, Yr = r;
        }
      },
      syncUpdates: Ur,
      interactiveUpdates: function interactiveUpdates(e, t, n) {
        if (Yr) return e(t, n);
        qr || Wr || 0 === Br || (fi(Br, !1), Br = 0);
        var r = Yr,
            i = qr;
        qr = Yr = !0;

        try {
          return e(t, n);
        } finally {
          Yr = r, (qr = i) || Wr || fi(1073741823, !1);
        }
      },
      flushInteractiveUpdates: function flushInteractiveUpdates() {
        Wr || 0 === Br || (fi(Br, !1), Br = 0);
      },
      flushControlled: function flushControlled(e) {
        var t = qr;
        qr = !0;

        try {
          Ur(e);
        } finally {
          (qr = t) || Wr || fi(1073741823, !1);
        }
      },
      flushSync: function flushSync(e, t) {
        Wr && l("187");
        var n = qr;
        qr = !0;

        try {
          return Ur(e, t);
        } finally {
          qr = n, fi(1073741823, !1);
        }
      },
      getPublicRootInstance: function getPublicRootInstance(e) {
        if (!(e = e.current).child) return null;

        switch (e.child.tag) {
          case 5:
            return k(e.child.stateNode);

          default:
            return e.child.stateNode;
        }
      },
      findHostInstance: yi,
      findHostInstanceWithWarning: function findHostInstanceWithWarning(e) {
        return yi(e);
      },
      findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(e) {
        return null === (e = function (e) {
          if (!(e = E(e))) return null;

          for (var t = e;;) {
            if (5 === t.tag || 6 === t.tag) return t;
            if (t.child && 4 !== t.tag) t.child.return = t, t = t.child;else {
              if (t === e) break;

              for (; !t.sibling;) {
                if (!t.return || t.return === e) return null;
                t = t.return;
              }

              t.sibling.return = t.return, t = t.sibling;
            }
          }

          return null;
        }(e)) ? null : e.stateNode;
      },
      injectIntoDevTools: function injectIntoDevTools(e) {
        var t = e.findFiberByHostInstance;
        return function (e) {
          if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
          var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (t.isDisabled || !t.supportsFiber) return !0;

          try {
            var n = t.inject(e);
            Be = Qe(function (e) {
              return t.onCommitFiberRoot(n, e);
            }), He = Qe(function (e) {
              return t.onCommitFiberUnmount(n, e);
            });
          } catch (e) {}

          return !0;
        }(r({}, e, {
          findHostInstanceByFiber: function findHostInstanceByFiber(e) {
            return null === (e = w(e)) ? null : e.stateNode;
          },
          findFiberByHostInstance: function findFiberByHostInstance(e) {
            return t ? t(e) : null;
          }
        }));
      }
    };
    e.exports = vi.default || vi;
    var gi = e.exports;
    return e.exports = t, gi;
  };
}),
    ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    ReactPropTypesSecret_1 = ReactPropTypesSecret,
    schedulerTracing_production_min = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = 0;
  t.__interactionsRef = null, t.__subscriberRef = null, t.unstable_clear = function (e) {
    return e();
  }, t.unstable_getCurrent = function () {
    return null;
  }, t.unstable_getThreadID = function () {
    return ++n;
  }, t.unstable_trace = function (e, t, n) {
    return n();
  }, t.unstable_wrap = function (e) {
    return e;
  }, t.unstable_subscribe = function () {}, t.unstable_unsubscribe = function () {};
});
unwrapExports(schedulerTracing_production_min);
var schedulerTracing_production_min_1 = schedulerTracing_production_min.__interactionsRef,
    schedulerTracing_production_min_2 = schedulerTracing_production_min.__subscriberRef,
    schedulerTracing_production_min_3 = schedulerTracing_production_min.unstable_clear,
    schedulerTracing_production_min_4 = schedulerTracing_production_min.unstable_getCurrent,
    schedulerTracing_production_min_5 = schedulerTracing_production_min.unstable_getThreadID,
    schedulerTracing_production_min_6 = schedulerTracing_production_min.unstable_trace,
    schedulerTracing_production_min_7 = schedulerTracing_production_min.unstable_wrap,
    schedulerTracing_production_min_8 = schedulerTracing_production_min.unstable_subscribe,
    schedulerTracing_production_min_9 = schedulerTracing_production_min.unstable_unsubscribe,
    schedulerTracing_development = createCommonjsModule(function (e, t) {});
unwrapExports(schedulerTracing_development);
var schedulerTracing_development_1 = schedulerTracing_development.__interactionsRef,
    schedulerTracing_development_2 = schedulerTracing_development.__subscriberRef,
    schedulerTracing_development_3 = schedulerTracing_development.unstable_clear,
    schedulerTracing_development_4 = schedulerTracing_development.unstable_getCurrent,
    schedulerTracing_development_5 = schedulerTracing_development.unstable_getThreadID,
    schedulerTracing_development_6 = schedulerTracing_development.unstable_trace,
    schedulerTracing_development_7 = schedulerTracing_development.unstable_wrap,
    schedulerTracing_development_8 = schedulerTracing_development.unstable_subscribe,
    schedulerTracing_development_9 = schedulerTracing_development.unstable_unsubscribe,
    tracing = createCommonjsModule(function (e) {
  e.exports = schedulerTracing_production_min;
}),
    reactReconciler_development = createCommonjsModule(function (e) {}),
    reactReconciler = createCommonjsModule(function (e) {
  e.exports = reactReconciler_production_min;
}),
    name = "@inlet/react-pixi",
    version = "0.4.2",
    description = "Write PixiJS applications using React declarative style.",
    main = "index.js",
    module$1 = "module.js",
    author = "Patrick Brouwer",
    license = "MIT",
    repository = "git+https://github.com/inlet/react-pixi.git",
    scripts = {
  "docz:dev": "docz dev",
  "docz:build": "docz build",
  eslint: "eslint .",
  "build:watch": "cross-env NODE_ENV=development rollup -c --watch",
  "build:dev": "cross-env NODE_ENV=development rollup -c",
  "build:prod": "cross-env NODE_ENV=production rollup -c",
  build: "rimraf ./dist && npm run build:dev && npm run build:prod",
  test: "jest --silent",
  "test:watch": "jest --silent --watch",
  prepublish: 'if-env CI=true && echo "skip build" || (npm run test && npm run eslint && npm run build)'
},
    files = ["dist/", "LICENSE", "index.d.ts", "index.js", "umd.js", "module.js"],
    typings = "./index.d.ts",
    devDependencies = {
  "@babel/cli": "^7.1.5",
  "@babel/core": "^7.1.6",
  "@babel/plugin-proposal-class-properties": "^7.1.0",
  "@babel/plugin-proposal-decorators": "^7.1.6",
  "@babel/plugin-proposal-do-expressions": "^7.0.0",
  "@babel/plugin-proposal-export-default-from": "^7.0.0",
  "@babel/plugin-proposal-export-namespace-from": "^7.0.0",
  "@babel/plugin-proposal-function-bind": "^7.0.0",
  "@babel/plugin-proposal-function-sent": "^7.1.0",
  "@babel/plugin-proposal-json-strings": "^7.0.0",
  "@babel/plugin-proposal-logical-assignment-operators": "^7.0.0",
  "@babel/plugin-proposal-nullish-coalescing-operator": "^7.0.0",
  "@babel/plugin-proposal-numeric-separator": "^7.0.0",
  "@babel/plugin-proposal-optional-chaining": "^7.0.0",
  "@babel/plugin-proposal-pipeline-operator": "^7.0.0",
  "@babel/plugin-proposal-throw-expressions": "^7.0.0",
  "@babel/plugin-syntax-dynamic-import": "^7.0.0",
  "@babel/plugin-syntax-import-meta": "^7.0.0",
  "@babel/preset-env": "^7.1.6",
  "@babel/preset-react": "^7.0.0",
  "@types/jest": "^23.3.10",
  "@types/pixi.js": "^4.8.4",
  "@types/react": "^16.7.11",
  "@types/react-dom": "^16.0.11",
  "babel-core": "^7.0.0-bridge.0",
  "babel-eslint": "^10.0.1",
  "babel-jest": "^23.6.0",
  "canvas-prebuilt": "1",
  "cross-env": "^5.2.0",
  docz: "^0.11.1",
  eslint: "^5.9.0",
  "eslint-config-prettier": "^3.3.0",
  "eslint-plugin-prettier": "^3.0.0",
  "eslint-plugin-react": "^7.11.1",
  idx: "^2.5.2",
  "if-env": "^1.0.4",
  jest: "^23.5.0",
  lodash: "^4.17.10",
  "pixi.js": "^4.8.1",
  prettier: "^1.15.3",
  "prop-types": "^15.6.2",
  react: "^16.7.0-alpha.2",
  "react-dom": "^16.7.0-alpha.2",
  "react-test-renderer": "^16.7.0-alpha.2",
  rimraf: "^2.6.2",
  rollup: "^0.67.4",
  "rollup-plugin-babel": "^4.0.0-beta.2",
  "rollup-plugin-commonjs": "^9.2.0",
  "rollup-plugin-filesize": "^5.0.1",
  "rollup-plugin-json": "^3.0.0",
  "rollup-plugin-node-globals": "^1.2.1",
  "rollup-plugin-node-resolve": "^3.3.0",
  "rollup-plugin-replace": "^2.1.0",
  "rollup-plugin-terser": "^3.0.0"
},
    peerDependencies = {
  "pixi.js": "^4.7.1",
  "prop-types": "^15.6.1",
  react: "^16.7.0-alpha.2",
  "react-dom": "^16.7.0-alpha.2"
},
    dependencies = {
  fbjs: "^1.0.0",
  "performance-now": "^2.1.0",
  "react-reconciler": "^0.18.0-alpha.2"
},
    jest = {
  collectCoverage: !1,
  setupFiles: ["./test/bootstrap.js"],
  transform: {
    "^.+\\.jsx?$": "babel-jest"
  }
},
    pkg = {
  name: name,
  version: version,
  description: description,
  main: main,
  "umd:main": "umd.js",
  module: module$1,
  "jsnext:main": "module.js",
  author: author,
  license: license,
  repository: repository,
  scripts: scripts,
  files: files,
  typings: typings,
  devDependencies: devDependencies,
  peerDependencies: peerDependencies,
  dependencies: dependencies,
  jest: jest
},
    global$1 = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};

function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}

function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}

var cachedSetTimeout = defaultSetTimout,
    cachedClearTimeout = defaultClearTimeout;

function runTimeout(e) {
  if (cachedSetTimeout === setTimeout) return setTimeout(e, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) return cachedSetTimeout = setTimeout, setTimeout(e, 0);

  try {
    return cachedSetTimeout(e, 0);
  } catch (t) {
    try {
      return cachedSetTimeout.call(null, e, 0);
    } catch (t) {
      return cachedSetTimeout.call(this, e, 0);
    }
  }
}

function runClearTimeout(e) {
  if (cachedClearTimeout === clearTimeout) return clearTimeout(e);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) return cachedClearTimeout = clearTimeout, clearTimeout(e);

  try {
    return cachedClearTimeout(e);
  } catch (t) {
    try {
      return cachedClearTimeout.call(null, e);
    } catch (t) {
      return cachedClearTimeout.call(this, e);
    }
  }
}

"function" == typeof global$1.setTimeout && (cachedSetTimeout = setTimeout), "function" == typeof global$1.clearTimeout && (cachedClearTimeout = clearTimeout);
var currentQueue,
    queue = [],
    draining = !1,
    queueIndex = -1;

function cleanUpNextTick() {
  draining && currentQueue && (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}

function drainQueue() {
  if (!draining) {
    var e = runTimeout(cleanUpNextTick);
    draining = !0;

    for (var t = queue.length; t;) {
      for (currentQueue = queue, queue = []; ++queueIndex < t;) {
        currentQueue && currentQueue[queueIndex].run();
      }

      queueIndex = -1, t = queue.length;
    }

    currentQueue = null, draining = !1, runClearTimeout(e);
  }
}

function nextTick(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
    t[n - 1] = arguments[n];
  }
  queue.push(new Item(e, t)), 1 !== queue.length || draining || runTimeout(drainQueue);
}

function Item(e, t) {
  this.fun = e, this.array = t;
}

Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};

var title = "browser",
    platform = "browser",
    browser = !0,
    env = {},
    argv = [],
    version$1 = "",
    versions = {},
    release = {},
    config = {};

function noop() {}

var on = noop,
    addListener = noop,
    once = noop,
    off = noop,
    removeListener = noop,
    removeAllListeners = noop,
    emit = noop;

function binding(e) {
  throw new Error("process.binding is not supported");
}

function cwd() {
  return "/";
}

function chdir(e) {
  throw new Error("process.chdir is not supported");
}

function umask() {
  return 0;
}

var performance$1 = global$1.performance || {},
    performanceNow = performance$1.now || performance$1.mozNow || performance$1.msNow || performance$1.oNow || performance$1.webkitNow || function () {
  return new Date().getTime();
};

function hrtime(e) {
  var t = .001 * performanceNow.call(performance$1),
      n = Math.floor(t),
      r = Math.floor(t % 1 * 1e9);
  return e && (n -= e[0], (r -= e[1]) < 0 && (n--, r += 1e9)), [n, r];
}

var startTime = new Date();

function uptime() {
  return (new Date() - startTime) / 1e3;
}

var process = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version$1,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
},
    performanceNow$1 = createCommonjsModule(function (e) {
  (function () {
    var t, n, r, i, o, l;
    "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
      return performance.now();
    } : null != process && process.hrtime ? (e.exports = function () {
      return (t() - o) / 1e6;
    }, n = process.hrtime, i = (t = function t() {
      var e;
      return 1e9 * (e = n())[0] + e[1];
    })(), l = 1e9 * process.uptime(), o = i - l) : Date.now ? (e.exports = function () {
      return Date.now() - r;
    }, r = Date.now()) : (e.exports = function () {
      return new Date().getTime() - r;
    }, r = new Date().getTime());
  }).call(commonjsGlobal);
});

function appendChild(e, t) {
  e.addChild && (e.addChild(t), "function" == typeof t.didMount && t.didMount.call(t, t, e));
}

function removeChild(e, t) {
  "function" == typeof t.willUnmount && t.willUnmount.call(t, t, e), e.removeChild(t), t.destroy();
}

function insertBefore(e, t, n) {
  invariant_1(t !== n, "PixiFiber cannot insert node before itself");
  var r = -1 !== e.children.indexOf(t),
      i = e.getChildIndex(n);
  r ? e.setChildIndex(t, i) : e.addChildAt(t, i);
}

function diffProperties(e, t, n, r, i) {
  var o = null;

  for (var l in n) {
    !r.hasOwnProperty(l) && n.hasOwnProperty(l) && null != n[l] && (l === CHILDREN || (o || (o = []), o.push(l, null)));
  }

  for (var a in r) {
    var u = r[a],
        c = null != n ? n[a] : void 0;
    !r.hasOwnProperty(a) || u === c || null == u && null == c || a === CHILDREN || (o || (o = []), o.push(a, u));
  }

  return o;
}

var hostconfig = {
  getRootHostContext: function getRootHostContext(e) {
    return e;
  },
  getChildHostContext: function getChildHostContext() {
    return {};
  },
  getPublicInstance: function getPublicInstance(e) {
    return e;
  },
  prepareForCommit: function prepareForCommit() {},
  resetAfterCommit: function resetAfterCommit() {},
  createInstance: createElement,
  appendInitialChild: appendChild,
  finalizeInitialChildren: function finalizeInitialChildren(e, t, n) {
    return !1;
  },
  prepareUpdate: function prepareUpdate(e, t, n, r, i, o) {
    return diffProperties(e, t, n, r, i);
  },
  shouldSetTextContent: function shouldSetTextContent(e, t) {
    return !1;
  },
  shouldDeprioritizeSubtree: function shouldDeprioritizeSubtree(e, t) {
    var n = void 0 === t.alpha || t.alpha > 0,
        r = void 0 === t.renderable || !0 === t.renderable,
        i = void 0 === t.visible || !0 === t.visible;
    return !(n && r && i);
  },
  createTextInstance: function createTextInstance(e, t, n) {
    invariant_1(!1, "PixiFiber does not support text instances. Use `<Text /> component` instead.");
  },
  now: performanceNow$1,
  isPrimaryRenderer: !1,
  supportsMutation: !0,
  appendChild: appendChild,
  appendChildToContainer: appendChild,
  removeChild: removeChild,
  removeChildFromContainer: removeChild,
  insertBefore: insertBefore,
  insertInContainerBefore: insertBefore,
  commitUpdate: function commitUpdate(e, t, n, r, i) {
    var o = e && e.applyProps;
    "function" != typeof o && (o = applyDefaultProps), o(e, r, i);
  },
  commitMount: function commitMount(e, t, n, r, i) {},
  commitTextUpdate: function commitTextUpdate(e, t, n) {},
  resetTextContent: function resetTextContent(e) {}
},
    PixiFiber = reactReconciler(hostconfig),
    VERSION = pkg.version,
    PACKAGE_NAME = pkg.name,
    roots = new Map();

function render(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
  invariant_1(Container.prototype.isPrototypeOf(t), "Invalid argument `container`, expected instance of `PIXI.Container`.");
  var r = roots.get(t);
  return r || (r = PixiFiber.createContainer(t), roots.set(t, r)), PixiFiber.updateContainer(e, r, void 0, n), injectDevtools(), PixiFiber.getPublicRootInstance(r);
}

function injectDevtools() {
  PixiFiber.injectIntoDevTools({
    bundleType: 0,
    version: VERSION,
    rendererPackageName: PACKAGE_NAME,
    findHostInstanceByFiber: PixiFiber.findHostInstance
  });
}

function emptyFunction() {}

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function e(e, t, n, r, i, o) {
    if (o !== ReactPropTypesSecret_1) {
      var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw l.name = "Invariant Violation", l;
    }
  }

  function t() {
    return e;
  }

  e.isRequired = e;
  var n = {
    array: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t
  };
  return n.checkPropTypes = emptyFunction, n.PropTypes = n, n;
},
    propTypes = createCommonjsModule(function (e) {
  e.exports = factoryWithThrowingShims();
}),
    Context = React.createContext(null),
    AppProvider = Context.Provider,
    AppConsumer = Context.Consumer,
    withPixiApp = function withPixiApp(e) {
  var t = React.forwardRef(function (t, n) {
    return React.createElement(AppConsumer, null, function (r) {
      return React.createElement(e, _extends({}, t, {
        ref: n,
        app: r
      }));
    });
  });
  return t.displayName = "withPIXIApp(".concat(e.displayName || e.name, ")"), t;
},
    noop$1 = function noop$1() {},
    propTypes$1 = {
  width: propTypes.number,
  height: propTypes.number,
  onMount: propTypes.func,
  onUnmount: propTypes.func,
  raf: propTypes.bool,
  renderOnComponentChange: propTypes.bool,
  children: propTypes.node,
  options: propTypes.shape({
    antialias: propTypes.bool,
    autoStart: propTypes.bool,
    width: propTypes.number,
    height: propTypes.number,
    transparent: propTypes.bool,
    preserveDrawingBuffer: propTypes.bool,
    resolution: propTypes.number,
    forceCanvas: propTypes.bool,
    backgroundColor: propTypes.number,
    clearBeforeRender: propTypes.bool,
    roundPixels: propTypes.bool,
    forceFXAA: propTypes.bool,
    legacy: propTypes.bool,
    powerPreference: propTypes.string,
    sharedTicker: propTypes.bool,
    sharedLoader: propTypes.bool,
    view: function view(e, t, n) {
      var r = e[t];
      void 0 !== r && invariant_1(r instanceof HTMLCanvasElement, "Invalid prop `view` of type ".concat(_typeof(r), ", supplied to ").concat(n, ", expected `<canvas> Element`"));
    }
  })
},
    defaultProps = {
  width: 800,
  height: 600,
  onMount: noop$1,
  onUnmount: noop$1,
  raf: !0,
  renderOnComponentChange: !0
};

function getCanvasProps(e) {
  var t = _toConsumableArray(Object.keys(propTypes$1)).concat(_toConsumableArray(Object.keys(PROPS_DISPLAY_OBJECT)));

  return Object.keys(e).filter(function (e) {
    return !t.includes(e);
  }).reduce(function (t, n) {
    return _objectSpread({}, t, _defineProperty({}, n, e[n]));
  }, {});
}

var Stage = function (e) {
  function t() {
    var e, n;

    _classCallCheck(this, t);

    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
      i[o] = arguments[o];
    }

    return _defineProperty(_assertThisInitialized(_assertThisInitialized(n = _possibleConstructorReturn(this, (e = _getPrototypeOf(t)).call.apply(e, [this].concat(i))))), "_canvas", null), _defineProperty(_assertThisInitialized(_assertThisInitialized(n)), "app", null), n;
  }

  return _inherits(t, React.Component), _createClass(t, [{
    key: "UNSAFE_componentWillMount",
    value: function value() {
      invariant_1(runningInBrowser(), "Cannot mount Stage, window object is not defined");
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      var e = this.props,
          t = e.onMount,
          n = e.width,
          r = e.height,
          i = e.options,
          o = e.raf;
      this.app = new Application(n, r, _objectSpread({}, i, {
        view: this._canvas
      })), this.app.ticker.autoStart = !1, this.app.ticker[o ? "start" : "stop"](), this.mountNode = PixiFiber.createContainer(this.app.stage), PixiFiber.updateContainer(this.getChildren(), this.mountNode, this), injectDevtools(), t(this.app), this.renderStage();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e, t, n) {
      var r = this.props,
          i = r.width,
          o = r.height,
          l = r.raf;
      e.height === o && e.width === i || this.app.renderer.resize(i, o), e.raf !== l && this.app.ticker[l ? "start" : "stop"](), PixiFiber.updateContainer(this.getChildren(), this.mountNode, this), this.renderStage();
    }
  }, {
    key: "getChildren",
    value: function value() {
      var e = this.props.children;
      return React.createElement(AppProvider, {
        value: this.app
      }, e);
    }
  }, {
    key: "componentDidCatch",
    value: function value(e, t) {
      console.error("Error occurred in `Stage`."), console.error(e), console.error(t);
    }
  }, {
    key: "renderStage",
    value: function value() {
      var e = this.props,
          t = e.renderOnComponentChange;
      !e.raf && t && this.app.renderer.render(this.app.stage);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.props.onUnmount(this.app), PixiFiber.updateContainer(null, this.mountNode, this), this.renderStage(), this.app.destroy();
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.props.options;
      return t && t.view ? (invariant_1(t.view instanceof HTMLCanvasElement, "options.view needs to be a `HTMLCanvasElement`"), null) : React.createElement("canvas", _extends({}, getCanvasProps(this.props), {
        ref: function ref(t) {
          return e._canvas = t;
        }
      }));
    }
  }]), t;
}();

function useTick(e) {
  var t = useContext(Context);
  invariant_1(t instanceof Application, "No Context found with `%s`. Make sure to wrap component with `%s`", "PIXI.Application", "AppProvider"), useEffect(function () {
    return t.ticker.add(e), function () {
      return t.ticker.remove(e);
    };
  }, []);
}

function useApp() {
  return useContext(Context);
}

Stage.propTypes = propTypes$1, Stage.defaultProps = defaultProps;
var BitmapText$1 = TYPES.BitmapText,
    Container$2 = TYPES.Container,
    Graphics$2 = TYPES.Graphics,
    NineSlicePlane$1 = TYPES.NineSlicePlane,
    ParticleContainer$1 = TYPES.ParticleContainer,
    Sprite$2 = TYPES.Sprite,
    Text$2 = TYPES.Text,
    TilingSprite$1 = TYPES.TilingSprite,
    Mesh$1 = TYPES.Mesh,
    Rope$1 = TYPES.Rope;
export { render, Stage, withPixiApp, PixiComponent, PixiFiber, AppProvider, AppConsumer, Context as AppContext, useTick, useApp, BitmapText$1 as BitmapText, Container$2 as Container, Graphics$2 as Graphics, NineSlicePlane$1 as NineSlicePlane, ParticleContainer$1 as ParticleContainer, Sprite$2 as Sprite, Text$2 as Text, TilingSprite$1 as TilingSprite, Mesh$1 as Mesh, Rope$1 as Rope };